/* global klaviyo */
/**
 *
 *  CorporatePage
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 21/07/2024.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useEffect, useState, useCallback, useRef } from "react";
import { Dimensions } from "react-native";
import { useHistory, useParams, useLocation, Link } from "react-router-dom";

import { useAppState } from "../../../state";
import { useRegion } from "../../../context/RegionProvider";
// import { useSignUpState } from "../../state/SignUpState";

// Components
import Button from "../../Button/Button";
import Header from "../../Homepage/Header/Header";
import Footer from "../../Footer/Footer";
import ScrollToTopOnMount from "../../ScrollToTopOnMount/ScrollToTopOnMount";
import SliderNextArrow from "../../SliderNextButton/SliderNextButton";

// Hooks
import useTheme from "../../ThemeProvider/useTheme/useTheme";

// Icons
import ArrowRightIcon from "../../../icons/ArrowRightIcon";

// Utils
// import { clientWidth, makeCancelable } from "../../../utils";
import { modalStyles } from "../../../constants";

// Images
import heroImg from "./hero.jpg";
import heroImg2x from "./hero@2x.jpg";
import heroImg3x from "./hero@3x.jpg";
import heroMobileImg from "./hero-mobile.jpg";
import heroMobileImg2x from "./hero-mobile@2x.jpg";
import heroMobileImg3x from "./hero-mobile@3x.jpg";

import benefits1 from "./corporate-page-benefits-1.jpg";
import benefits12x from "./corporate-page-benefits-1@2x.jpg";
import benefits2 from "./corporate-page-benefits-2.jpg";
import benefits22x from "./corporate-page-benefits-2@2x.jpg";
import benefits3 from "./corporate-page-benefits-3.jpg";
import benefits32x from "./corporate-page-benefits-3@2x.jpg";
import benefits4 from "./corporate-page-benefits-4.jpg";
import benefits42x from "./corporate-page-benefits-4@2x.jpg";
import benefits5 from "./corporate-page-benefits-5.jpg";
import benefits52x from "./corporate-page-benefits-5@2x.jpg";
import benefits6 from "./corporate-page-benefits-6.jpg";
import benefits62x from "./corporate-page-benefits-6@2x.jpg";
import benefits7 from "./corporate-page-benefits-7.jpg";
import benefits72x from "./corporate-page-benefits-7@2x.jpg";
import benefits8 from "./corporate-page-benefits-8.jpg";
import benefits82x from "./corporate-page-benefits-8@2x.jpg";

import disciplinePilates from "./corporate-page-disciplines-pilates.jpg";
import disciplinePilates2x from "./corporate-page-disciplines-pilates@2x.jpg";
import disciplinePilates3x from "./corporate-page-disciplines-pilates@3x.jpg";
import disciplineMeditation from "./corporate-page-disciplines-meditation.jpg";
import disciplineMeditation2x from "./corporate-page-disciplines-meditation@2x.jpg";
import disciplineMeditation3x from "./corporate-page-disciplines-meditation@3x.jpg";
import disciplineYoga from "./corporate-page-disciplines-yoga.jpg";
import disciplineYoga2x from "./corporate-page-disciplines-yoga@2x.jpg";
import disciplineYoga3x from "./corporate-page-disciplines-yoga@3x.jpg";
import disciplineRunning from "./corporate-page-disciplines-running.jpg";
import disciplineRunning2x from "./corporate-page-disciplines-running@2x.jpg";
import disciplineRunning3x from "./corporate-page-disciplines-running@3x.jpg";

import solutionsEvents from "./corporate-page-solutions-events.png";
import solutionsEvents2x from "./corporate-page-solutions-events@2x.png";
import solutionsHotels from "./corporate-page-solutions-hotels.png";
import solutionsHotels2x from "./corporate-page-solutions-hotels@2x.png";
import solutionsHospitality from "./corporate-page-solutions-hospitality.png";
import solutionsHospitality2x from "./corporate-page-solutions-hospitality@2x.png";
import solutionsCareHomes from "./corporate-page-solutions-care-homes.png";
import solutionsCareHomes2x from "./corporate-page-solutions-care-homes@2x.png";
import solutionsCoWorkingSpaces from "./corporate-page-solutions-co-working-spaces.png";
import solutionsCoWorkingSpaces2x from "./corporate-page-solutions-co-working-spaces@2x.png";

import inspirationStationImg from "./corporate-page-inspiration-station.png";
import inspirationStationImg2x from "./corporate-page-inspiration-station@2x.png";
import inspirationStationImg3x from "./corporate-page-inspiration-station@3x.png";

import qualityImg from "./corporate-page-quality.jpg";
import qualityImg2x from "./corporate-page-quality@2x.jpg";
import qualityImg3x from "./corporate-page-quality@3x.jpg";

import qualityMobileImg from "./corporate-page-quality-mobile.jpg";
import qualityMobileImg2x from "./corporate-page-quality-mobile@2x.jpg";
import qualityMobileImg3x from "./corporate-page-quality-mobile@3x.jpg";

import flexibilityImg from "./corporate-page-flexibility.jpg";
import flexibilityImg2x from "./corporate-page-flexibility@2x.jpg";
import flexibilityImg3x from "./corporate-page-flexibility@3x.jpg";
import flexibilityMobileImg from "./corporate-page-flexibility-mobile.jpg";
import flexibilityMobileImg2x from "./corporate-page-flexibility-mobile@2x.jpg";
import flexibilityMobileImg3x from "./corporate-page-flexibility-mobile@3x.jpg";

import personalisationImg from "./corporate-page-personalisation.jpg";
import personalisationImg2x from "./corporate-page-personalisation@2x.jpg";
import personalisationImg3x from "./corporate-page-personalisation@3x.jpg";
import personalisationMobileImg from "./corporate-page-personalisation-mobile.jpg";
import personalisationMobileImg2x from "./corporate-page-personalisation-mobile@2x.jpg";
import personalisationMobileImg3x from "./corporate-page-personalisation-mobile@3x.jpg";

import averyLogo from "./avery.png";
import averyLogo2x from "./avery@2x.png";
import averyLogo3x from "./avery@3x.png";

import firmdaleHotelsLogo from "./firmdale-hotels.png";
import firmdaleHotelsLogo2x from "./firmdale-hotels@2x.png";
import firmdaleHotelsLogo3x from "./firmdale-hotels@3x.png";

import weworkLogo from "./wework.png";
import weworkLogo2x from "./wework@2x.png";
import weworkLogo3x from "./wework@3x.png";

import redLogo from "./red-logo.png";
import redLogo2x from "./red-logo@2x.png";
import redLogo3x from "./red-logo@3x.png";

import blakesLondonLogo from "./blakes-london.png";
import blakesLondonLogo2x from "./blakes-london@2x.png";
import blakesLondonLogo3x from "./blakes-london@3x.png";

import TruBeLogo from "../../Footer/TruBeLogo";

import SkyGarden from "./SkyGarden";
import WorkAndPlay from "./WorkAndPlay";
import { clientWidth } from "../../../utils";
import Slider from "react-slick";
import { TruBeInPressSlider } from "../../TruBeInPress/TruBeInPress";
import CorporateContactForm from "../../CorporateContactForm/CorporateContactForm";

const sliderResponsiveSettings = [
  {
    breakpoint: 640,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "0",
    },
  },
  {
    breakpoint: 960,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "0",
    },
  },
  {
    breakpoint: 1400,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "0",
    },
  },
  {
    breakpoint: 1600,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "0",
    },
  },
  {
    breakpoint: 5000,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "0",
    },
  },
];

const { height } = Dimensions.get("window");

const BenefitsCard = ({ images, text }) => (
  <div className="benefits-card tbk-relative tbk-flex tbk-grow tbk-rounded-lg tbk-border tbk-border-grey-inactive tbk-bg-basic-white lg:tbk-block">
    <div className="tbk-relative tbk-w-26 tbk-shrink-0 tbk-overflow-hidden tbk-rounded-lg md:tbk-h-54 md:tbk-w-full">
      <picture className="js-progressive-image">
        <source
          srcSet={`${images[0]} 1x, ${images[1]} 2x`}
          media="(minWidth: 760px)"
          type="image/png"
        />
        <source srcSet={`${images[0]} 1x, ${images[1]} 2x`} type="image/png" />
        <img
          className="tbk-h-full tbk-rounded-lg tbk-object-cover md:tbk-absolute"
          aria-hidden="true"
          alt="Personal Trainers in London"
          src={images[0]}
          style={
            {
              // position: "absolute",
              // objectFit: "cover",
              // verticalAlign: "bottom",
            }
          }
        />
      </picture>
      <div className="benefits-card-gradient" />
    </div>
    <div
      className="tbk-grow tbk-px-2 tbk-pt-1 tbk-pb-1 md:tbk-pt-0.5 md:tbk-pb-2"
      style={{ minHeight: "72px" }}
    >
      <div className="tbk-bottom-2 tbk-left-2 tbk-right-2 lg:tbk-absolute">
        <p className="tbk-text-main tbk-mb-0 tbk-text-primary lg:tbk-text-left">
          {text}
        </p>
      </div>
    </div>
  </div>
);

export default function CorporatePage() {
  const history = useHistory();
  const location = useLocation();

  const { theme } = useTheme();
  const { region } = useRegion();

  const defaultCustomStyle = Object.assign(
    {
      content: {
        ...modalStyles.default.content,
        width: "358px",
      },
    },
    { overlay: { ...modalStyles.default.overlay, zIndex: 1060 } }
  );

  const { user, sendSupportRequest, isFetching } = useAppState();

  const heroRef = React.useRef(null);

  const getInTouchRef = React.useRef(null);

  const slickInitialised = true;

  const isUserLoggedIn = !!(user && user.id);

  const scrollToForm = useCallback(() => {
    getInTouchRef.current.scrollIntoView({ behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (region !== "GB") {
      history.push("/");
    }
  }, [region]);

  return (
    <div className="corporate-page tbk-bg-grey-light">
      <ScrollToTopOnMount />
      <Header
        showLinks
        heroRef={heroRef}
        isFixed
        // onViewCoachesNavLinkClick={() => clearAvailablePartnersLoaded()}
      />

      <div
        ref={heroRef}
        className="tbk-relative tbk-flex tbk-min-h-[857px] tbk-items-end tbk-bg-[#202831] tbk-pt-7 lg:tbk-h-[80vh] lg:tbk-min-h-[664px] lg:tbk-items-center"
      >
        <div className="tbk-absolute tbk-right-0 tbk-top-0 tbk-left-0 tbk-w-full tbk-overflow-hidden lg:tbk-bottom-0 lg:tbk-h-full lg:tbk-h-[80vh] lg:tbk-min-h-[664px]">
          <picture className="tbk-h-full tbk-grow">
            <source
              media="(min-width: 768px)"
              srcSet={`${heroImg} 1x, ${heroImg2x} 2x, ${heroImg3x} 3x`}
            />
            <source
              srcSet={`${heroMobileImg} 1x, ${heroMobileImg2x} 2x, ${heroMobileImg3x} 3x`}
            />

            <img
              className="tbk-h-full tbk-w-full tbk-object-cover md:tbk-h-full"
              src={heroImg}
              alt="Hero"
            />
          </picture>
        </div>
        <div className="tbk-container tbk-z-1 tbk-mx-auto tbk-px-2 lg:tbk-px-8">
          <div className="tbk-relative tbk-h-full tbk-pt-2 md:tbk-grid md:tbk-grid-cols-2 md:tbk-items-end lg:tbk-grid-cols-homepage-hero lg:tbk-pb-7 lg:tbk-pt-6">
            <div className="">
              <div className="tbk-text-epic-medium lg:tbk-text-epic-bold tbk-mb-1 !tbk-leading-none tbk-text-basic-white lg:tbk-mb-4">
                <div className="lg:tbk-text-coral">TruBe</div>
                {/*<br />*/}
                Empowerment
              </div>
              <p className="tbk-text-h3-subtitle lg:tbk-text-main tbk-mb-4 tbk-text-basic-white">
                At TruBe, we provide you with the opportunity to motivate,
                reenergise, reengage, and make your employees more efficient
                through the benefits of our live health and fitness classes.
              </p>
              <Button
                size={"md"}
                variant={"secondary"}
                color={"transparent"}
                className="tbk-mb-4 tbk-inline-block tbk-hidden tbk-w-45 lg:tbk-mb-0 lg:tbk-block"
                endIcon={<ArrowRightIcon />}
                onClick={scrollToForm}
              >
                Contact Us
              </Button>
            </div>
            <div className="tbk-flex md:tbk-justify-end">
              {/*<a*/}
              {/*  href="https://apps.apple.com/us/app/trube/id6449003944"*/}
              {/*  className=""*/}
              {/*>*/}
              {/*  <AppleAppStore className="" width={165} height={48} />*/}
              {/*</a>*/}
            </div>
          </div>

          <div className="hero-bottom-line u-flex-middle hidden-xs tbk-mb-1 tbk-flex tbk-flex-wrap tbk-items-center tbk-justify-between md:tbk-mb-0">
            <div className="_tbk-mr-3 tbk-mb-5 tbk-min-w-0 tbk-shrink-0 tbk-grow tbk-basis-1/2 tbk-text-center md:tbk-mr-1 md:tbk-basis-auto lg:tbk-order-5">
              <WorkAndPlay className="tbk-inline-block tbk-shrink-0 " />
            </div>

            <div className="tbk-mr-3_ tbk-mb-5 tbk-min-w-0 tbk-grow tbk-basis-1/2 tbk-text-center md:tbk-mr-1 md:tbk-basis-auto lg:tbk-order-3">
              <img
                className="tbk-inline-block tbk-shrink-0"
                src={firmdaleHotelsLogo}
                srcSet={`${firmdaleHotelsLogo} 1x, ${firmdaleHotelsLogo2x} 2x, ${firmdaleHotelsLogo3x} 3x`}
                alt="Firmdale Hotels"
                style={{ width: "156px", height: "43px" }}
              />
            </div>

            <br />
            <div className="tbk-mb-5 tbk-grow tbk-basis-1/4 tbk-text-right md:tbk-basis-auto md:tbk-text-center lg:tbk-order-2">
              <SkyGarden className="tbk-mr-3 tbk-inline-block tbk-shrink-0 md:tbk-mr-1 " />
            </div>

            <div className=" tbk-mb-5 lg:tbk-order-1">
              <img
                className="tbk-mr-3  md:tbk-mr-1"
                src={averyLogo}
                srcSet={`${averyLogo} 1x, ${averyLogo2x} 2x, ${averyLogo3x} 3x`}
                alt="Avery"
                style={{ width: "78px", height: "44px" }}
              />
            </div>

            <div className="tbk-mb-5 tbk-grow tbk-basis-1/4 md:tbk-basis-auto md:tbk-text-center lg:tbk-order-6">
              <img
                className="tbk-mr-3_ tbk-inline-block tbk-shrink-0 md:tbk-mr-1"
                src={redLogo}
                srcSet={`${redLogo} 1x, ${redLogo2x} 2x, ${redLogo3x} 3x`}
                alt="Roundhouse"
                style={{ width: "55px", height: "56px" }}
              />
            </div>

            <br />

            <div className="tbk-mb-5 tbk-grow tbk-basis-1/2 tbk-text-right md:tbk-basis-auto  lg:tbk-order-7">
              <img
                className="md:tb-mr-1 tbk-mr-3 tbk-inline-block"
                src={blakesLondonLogo}
                srcSet={`${blakesLondonLogo} 1x, ${blakesLondonLogo2x} 2x, ${blakesLondonLogo3x} 3x`}
                alt="Blakes London"
                style={{ width: "132px", height: "37px" }}
              />
            </div>

            <div className="tbk-mb-5 tbk-grow tbk-basis-1/2 tbk-text-center md:tbk-basis-auto lg:tbk-order-4">
              <img
                className="tbk-inline-block tbk-shrink-0 "
                src={weworkLogo}
                srcSet={`${weworkLogo} 1x, ${weworkLogo2x} 2x, ${weworkLogo3x} 3x`}
                alt="WeWork"
                style={{ width: "119px", height: "25px" }}
              />
            </div>
          </div>
        </div>
      </div>

      <section className="tbk-relative tbk-overflow-hidden tbk-bg-basic-white tbk-pt-5 tbk-pb-6 md:tbk-pb-8 md:tbk-pb-8 md:tbk-pt-8">
        <div className="tbk-container tbk-mx-auto tbk-px-2 lg:tbk-px-9">
          <div className="row tb-gutter-md-spacious u-flex-lg-row u-flex-top u-flex-md-space-between_ md:tbk-mb-7_ tbk-flex tbk-items-center tbk-justify-center">
            <div className="tbk-mb-7 tbk-w-170">
              <div className="">
                <h2 className="text-uppercase tbk-text-h2-black md:tbk-text-epic-medium tbk-mt-3 tbk-text-center !tbk-leading-small tbk-tracking-tight tbk-text-primary md:tbk-mt-0 md:tbk-mb-3 md:tbk-leading-none md:tbk-tracking-normal lg:tbk-px-0">
                  Physical <span className="tbk-text-coral">Well-Being</span> at
                  Work
                </h2>
                <p className="tbk-text-main tbk-mb-7 tbk-hidden tbk-text-center tbk-text-primary md:tbk-mt-3">
                  TruBe excels in delivering a premium fitness and well-being
                  service through its dedicated concierge, emphasising{" "}
                  <span className="tbk-text-coral">Quality</span>,{" "}
                  <span className="tbk-text-coral">Flexibility</span>, and{" "}
                  <span className="tbk-text-coral">Personalisation</span>.
                </p>
              </div>
            </div>
          </div>

          <div className="tbk-mb-7 tbk-grid md:tbk-grid-cols-corporate-layout md:tbk-gap-5">
            <div className="col-5 tbk-mb-4">
              <picture className="js-progressive-image md:tbk-mr-5 md:tbk-pr-1">
                <source
                  srcSet={`${qualityImg} 1x, ${qualityImg2x} 2x, ${qualityImg3x} 3x`}
                  media="(min-width: 760px)"
                  type="image/png"
                />
                <source
                  srcSet={`${qualityMobileImg} 1x, ${qualityMobileImg2x} 2x, ${qualityMobileImg3x} 3x`}
                  type="image/png"
                />
                <img
                  className="tbk-inline-block tbk-w-full tbk-rounded-2xl tbk-object-cover"
                  aria-hidden="true"
                  alt="Personal Trainers in London"
                  src={qualityImg}
                  style={{
                    verticalAlign: "bottom",
                    maxWidth: "485px",
                  }}
                />
              </picture>
            </div>
            <div className="col-7 md:tbk-ml-1">
              <h3 className="tbk-text-title-bold md:tbk-text-title-bold tbk-mb-1 md:tbk-mt-0">
                Quality
              </h3>
              <p className="tbk-text-main tbk-mb-3">
                Our Quality service is upheld by a select team of experienced
                trainers, ensuring for a best-in-class guidance. TruBe's
                trainers are not only experts in fitness but also deeply
                knowledgeable about the specific challenges of desk-bound
                professionals. This expertise allows them to address the unique
                pains and strains associated with sedentary work, offering
                effective solutions for clients working in the corporate world.
              </p>
              <button
                className="tbk-text-h3-subtitle tbk-mt-1 tbk-mb-1 tbk-inline-flex tbk-items-center tbk-text-coral hover:tbk-text-coral-light lg:tbk-mb-0"
                onClick={scrollToForm}
              >
                <div className="">Enquire About Our Workshops</div>
                <ArrowRightIcon />
              </button>
            </div>
          </div>

          <div className="tbk-mb-7 tbk-grid md:tbk-grid-cols-corporate-layout md:tbk-gap-5">
            <div className="col-5 tbk-mb-4">
              <picture className="js-progressive-image md:tbk-mr-5 md:tbk-pr-1">
                <source
                  srcSet={`${flexibilityImg} 1x, ${flexibilityImg2x} 2x, ${flexibilityImg3x} 3x`}
                  media="(min-width: 760px)"
                  type="image/png"
                />
                <source
                  srcSet={`${flexibilityMobileImg} 1x, ${flexibilityMobileImg2x} 2x, ${flexibilityMobileImg3x} 3x`}
                  type="image/png"
                />
                <img
                  className="tbk-inline-block tbk-w-full tbk-rounded-2xl tbk-object-cover"
                  aria-hidden="true"
                  alt="Personal Trainers in London"
                  src={flexibilityImg}
                  style={{
                    verticalAlign: "bottom",
                    maxWidth: "485px",
                  }}
                />
              </picture>
            </div>
            <div className="col-7 md:tbk-ml-1">
              <h3 className="tbk-text-title-bold md:tbk-text-title-bold tbk-mb-1 md:tbk-mt-0">
                Flexibility
              </h3>
              <p className="tbk-text-main tbk-mb-3">
                Flexibility is the cornerstone of our approach, providing
                clients with the freedom to schedule sessions at their
                convenience. Whether it's a busy executive fitting a session
                into a tight schedule or a team of employees looking for group
                fitness options, we adapt to your needs, making fitness
                accessible to all.
              </p>
              <button
                className="tbk-text-h3-subtitle tbk-mt-1 tbk-mb-1 tbk-inline-flex tbk-items-center tbk-text-coral hover:tbk-text-coral-light lg:tbk-mb-0"
                onClick={scrollToForm}
              >
                <div className="">Enquire About Our Workshops</div>
                <ArrowRightIcon />
              </button>
            </div>
          </div>

          <div className="tbk-grid md:tbk-grid-cols-corporate-layout md:tbk-gap-5">
            <div className="col-5 tbk-mb-4">
              <picture className="js-progressive-image tbk-mr-5 tbk-pr-1">
                <source
                  srcSet={`${personalisationImg} 1x, ${personalisationImg2x} 2x, ${personalisationImg3x} 3x`}
                  media="(min-width: 760px)"
                  type="image/png"
                />
                <source
                  srcSet={`${personalisationMobileImg} 1x, ${personalisationMobileImg2x} 2x, ${personalisationMobileImg3x} 3x`}
                  type="image/png"
                />
                <img
                  className="tbk-inline-block tbk-w-full tbk-rounded-2xl tbk-object-cover"
                  aria-hidden="true"
                  alt="Personal Trainers in London"
                  src={personalisationImg}
                  style={{
                    verticalAlign: "bottom",
                    maxWidth: "485px",
                  }}
                />
              </picture>
            </div>
            <div className="col-7 md:tbk-ml-1">
              <h3 className="tbk-text-title-bold md:tbk-text-title-bold tbk-mb-1 md:tbk-mt-0">
                Personalisation
              </h3>
              <p className="tbk-text-main tbk-mb-3">
                Each session is meticulously tailored to meet the unique needs
                and goals of every client. Whether the focus is on strength
                training, stress management, or a combination of both, TruBe's
                concierge ensures that the well-being journey is deeply
                personalised and effective.
                <br />
                <br />
                Building connections between the trainer and their employees is
                a key strength of TruBe. This personalised approach fosters
                trust and collaboration, going beyond the traditional
                client-trainer relationship. Such connections motivate employees
                to stay committed to their fitness and well-being goals and
                enhance the overall workplace atmosphere.
              </p>
              <button
                className="tbk-text-h3-subtitle tbk-mt-1 tbk-mb-1 tbk-inline-flex tbk-items-center tbk-text-coral hover:tbk-text-coral-light lg:tbk-mb-0"
                onClick={scrollToForm}
              >
                <div className="">Enquire About Our Workshops</div>
                <ArrowRightIcon />
              </button>
            </div>
          </div>
        </div>
      </section>

      <section
        className="section-solutions background-fill_ tbk-bg-basic-white tbk-pt-7 tbk-pb-7 md:tbk-pt-8 md:tbk-pb-7"
        style={{ overflow: "hidden" }}
      >
        <div className="tbk-container tbk-mx-auto tbk-px-2 lg:tbk-px-2">
          <div className="row tbk-items-center">
            <div className="col-6 tbk-mb-7_">
              <h2 className="tbk-text-h2-black md:tbk-text-epic-medium text-uppercase tbk-mb-4 tbk-text-center !tbk-leading-small tbk-tracking-tight tbk-text-primary md:tbk-mb-7 md:tbk-leading-none md:tbk-tracking-normal">
                The <span className="tbk-text-coral">Benefits</span> of Our{" "}
                <br className={"tbk-hidden lg:tbk-block"} />
                Classes for You
              </h2>
            </div>
          </div>
          {/*<?php if (false && isMobile()): ?>*/}

          {/*<?php else: ?>*/}
          <div className="tbk-grid tbk-flex-wrap tbk-gap-2 md:tbk-grid-cols-3 lg:tbk-items-center xl:tbk-grid-cols-4">
            <div className="tbk-mb-3_ u-flex-space-between u-flex-wrap u-flex-lg-nowrap tbk-flex">
              <BenefitsCard
                images={[benefits1, benefits12x]}
                text="Improved morale of individuals within the business"
              />
            </div>

            <div className="tbk-mb-3_ u-flex-space-between u-flex-wrap u-flex-lg-nowrap tbk-flex">
              <BenefitsCard
                images={[benefits2, benefits22x]}
                text="Aid positive mental wellbeing within the company"
              />
            </div>
            <div className="tbk-mb-3_ u-flex-space-between u-flex-wrap u-flex-lg-nowrap tbk-flex">
              <BenefitsCard
                images={[benefits3, benefits32x]}
                text="Reduced staff sick days and stress levels, anxiety, and depression "
              />
            </div>
            <div className="tbk-mb-3_ u-flex-space-between u-flex-wrap u-flex-lg-nowrap tbk-flex">
              <BenefitsCard
                images={[benefits4, benefits42x]}
                text="Increased endorphins to create happier and more resilient employees "
              />
            </div>
            <div className="tbk-mb-3_ u-flex-space-between u-flex-wrap u-flex-lg-nowrap tbk-flex">
              <BenefitsCard
                images={[benefits5, benefits52x]}
                text="Improved employee, employer relationships"
              />
            </div>
            <div className="tbk-mb-3_ u-flex-space-between u-flex-wrap u-flex-lg-nowrap tbk-flex">
              <BenefitsCard
                images={[benefits6, benefits62x]}
                text="Connect with the workforce that work from home or off-site"
              />
            </div>
            <div className="tbk-mb-3_ u-flex-space-between u-flex-wrap u-flex-lg-nowrap tbk-flex">
              <BenefitsCard
                images={[benefits7, benefits72x]}
                text="Improved staff retention and job satisfaction"
              />
            </div>
            <div className="tbk-mb-3_ u-flex-space-between u-flex-wrap u-flex-lg-nowrap tbk-flex">
              <BenefitsCard
                images={[benefits8, benefits82x]}
                text="Additional employee benefits for working with your business"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="tbk-relative tbk-hidden tbk-bg-basic-white tbk-pt-5 tbk-pb-7 md:tbk-pt-7 md:tbk-pb-7">
        <div className="tbk-container tbk-mx-auto tbk-px-2 lg:tbk-px-7">
          <div className="row u-flex-lg-row u-flex-top u-flex-md-space-between_ md:tbk-mb-7_ tbk-items-center">
            <div className="col-md-8">
              <div className="">
                <h2 className="tb-mg-t-5 tbk-text-headline tbk-text-md-h1-headline tbk-c-grey-main text-md-center">
                  Physical <span className="tbk-c-red">well-being</span> at work
                </h2>
                <p className="tbk-text-main tbk-c-black-grey tbk-mb-7 md:tbk-mt-5">
                  Investing in the health of your employees has never been more
                  prevalent than it has been today. With the changes that
                  occurred in 2020, then the switch to working from home and
                  less activity taking place, everyone's health and well-being
                  have all been impacted to a higher degree.
                </p>
              </div>
            </div>
            <div className="col-xs-8 col-md-10 tb-pd-b-5">
              <h3 className="tbk-text-quote-bold tbk-c-grey-main md:tbk-text-left_ tbk-mt-0 tbk-mb-4 tbk-text-center">
                In the UK:
              </h3>
              <div className="row u-flex-lg-row u-flex-stretch tb-gutter-condensed tbk-items-center">
                <div className="col-md-3 tb-mg-b-2">
                  <div className="tb-mg-x-auto tb-pd-l-5 tbk-relative tbk-h-full tbk-rounded-lg tbk-bg-grey-main tbk-p-2">
                    <div className="tb-pd-l-1 tbk-text-main tbk-c-basic-white">
                      <span
                        className="tbk-c-red tbk-absolute"
                        style={{ fontSize: "40px", left: "16px" }}
                      >
                        &#8729;
                      </span>
                      Over{" "}
                      <strong className="tbk-c-red_">
                        1.3 million workers
                      </strong>{" "}
                      suffer from work-related ill-health
                    </div>
                  </div>
                </div>
                <div className="col-md-3 tb-mg-b-2">
                  <div className="tb-mg-x-auto tb-pd-l-5 tbk-relative tbk-h-full tbk-rounded-lg tbk-bg-grey-main tbk-p-2">
                    <div className="tbk-text-main tbk-c-basic-white ">
                      <div
                        className="tbk-c-red tbk-absolute"
                        style={{ fontSize: "40px", left: "16px" }}
                      >
                        &#8729;
                      </div>
                      The average cost to a business is{" "}
                      <strong className="tbk-c-red_">£522 per employee</strong>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 tb-mg-b-2">
                  <div className="tb-mg-x-auto tb-pd-l-5 tbk-relative tbk-h-full tbk-rounded-lg tbk-bg-grey-main tbk-p-2">
                    <div className="tbk-text-main tbk-c-basic-white ">
                      <div
                        className="tbk-c-red tbk-absolute"
                        style={{ fontSize: "40px", left: "16px" }}
                      >
                        &#8729;
                      </div>
                      <strong className="tbk-c-red_">
                        25.7 million working days
                      </strong>{" "}
                      are lost per year through ill-health
                    </div>
                  </div>
                </div>
                <div className="col-md-3 tb-mg-b-2">
                  <div className="tb-mg-x-auto tb-pd-l-5 tbk-relative tbk-h-full tbk-rounded-lg tbk-bg-grey-main tbk-p-2">
                    <div className="tbk-text-main tbk-c-basic-white ">
                      <div
                        className="tbk-c-red tbk-absolute"
                        style={{ fontSize: "40px", left: "16px" }}
                      >
                        &#8729;
                      </div>
                      <strong className="tbk-c-red_">
                        £32 billion per year
                      </strong>{" "}
                      is due to health related issues
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row u-flex-lg-row u-flex-top u-flex-md-space-between_ md:tbk-mb-7_ tbk-items-center">
            <div className="col-xs-12 col-md-10">
              <h3 className="tbk-text-quote-bold tbk-c-grey-main md:tbk-text-left_ tbk-mt-0 tbk-mb-4 tbk-text-center">
                When you also consider that:
              </h3>
            </div>
            <div className="col-xs-8 col-md-10 tb-pd-b-5">
              <div className="row u-flex-lg-row u-flex-top tb-gutter-condensed tbk-items-center">
                <div className="col-md-4">
                  <div className="tbk-bg-red tb-pd-1 tb-pd-l-5 tbk-relative tbk-mb-1 tbk-h-full tbk-rounded-lg">
                    <div className="tb-pd-l-1 tbk-text-main tbk-c-basic-white">
                      <span
                        className="tbk-c-basic-white tbk-absolute"
                        style={{ fontSize: "40px", left: "16px" }}
                      >
                        &#8729;
                      </span>
                      Motivating yourself to exercise at home can be hard{" "}
                      <strong className="tbk-c-red_"></strong>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="tbk-bg-red tb-pd-1 tb-pd-l-5 tbk-relative tbk-mb-1 tbk-h-full tbk-rounded-lg">
                    <div className="tbk-text-main tbk-c-basic-white ">
                      <div
                        className="tbk-c-basic-white tbk-absolute"
                        style={{ fontSize: "40px", left: "16px" }}
                      >
                        &#8729;
                      </div>
                      Lacking a structure to your daily routine can make people
                      less productive
                      <strong className="tbk-c-red_"></strong>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="tbk-bg-red tb-pd-1 tb-pd-l-5 tbk-relative tbk-mb-1 tbk-h-full tbk-rounded-lg">
                    <div className="tbk-text-main tbk-c-basic-white ">
                      <div
                        className="tbk-c-basic-white tbk-absolute"
                        style={{ fontSize: "40px", left: "16px" }}
                      >
                        &#8729;
                      </div>
                      <strong className="tbk-c-red_"></strong>Social interaction
                      can be less common
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xs-10 col-md-6 col-lg-5 tbk-pt-5">
              <p className="tbk-text-epic-medium tbk-c-black-grey md:tbk-text-left_ tbk-mt-0 tbk-text-center">
                The impact of you physical and mental well-being begins to slip
                and can have a detrimental impact on both your work and your
                life.
              </p>
              <div className="tb-mg-t-5 tbk-text-center">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M31.9999 16C31.9999 24.8365 24.8365 32 16 32C7.16372 32 0 24.8365 0 16C0 7.16348 7.16372 0 16 0C24.8365 0 31.9999 7.16348 31.9999 16Z"
                    fill="#E94E32"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.1998 9.37934C19.211 11.2569 17.6984 12.7885 15.821 12.7999C13.9424 12.8117 12.4114 11.2982 12.4 9.42066C12.3888 7.54257 13.9016 6.011 15.7796 6.00007C17.6571 5.98834 19.1881 7.50126 19.1998 9.37934Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24.3997 22.8044C24.3997 22.8044 12.9027 16.0571 7.99976 23.4952C7.99976 23.4952 14.9196 29.5672 24.3997 22.8044Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.5993 13.6577C17.5993 13.6577 16.1933 18.4003 13.1583 18.4003C10.4803 18.4003 7.91406 12.6829 7.19934 12.6387C7.19934 12.6387 8.76229 10.7547 10.7929 12.0622C14.5564 14.4848 16.1035 14.2785 17.5993 13.6577Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.3995 18.3994C21.7149 18.4772 28.4704 12.1334 21.2636 9.6001C20.5304 14.5176 16.9664 17.6052 16.3995 18.3994Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tbk-relative tbk-bg-basic-white tbk-pb-2 tbk-pt-7 md:tbk-pt-7 md:tbk-pb-7">
        <div className="tbk-container tbk-mx-auto tbk-px-2 lg:tbk-px-2">
          <div className="row u-flex-lg-row u-flex-top u-flex-md-space-between_ md:tbk-mb-7_ tbk-items-center">
            <div className="col-md-8">
              <h2 className="tbk-text-h2-black md:tbk-text-epic-medium text-uppercase tbk-mb-4 tbk-text-center !tbk-leading-small tbk-tracking-tight tbk-text-primary md:tbk-mb-7 md:tbk-leading-none md:tbk-tracking-normal">
                <span className="tbk-text-coral">4</span> Unique Disciplines
              </h2>
            </div>
          </div>
          <div
            className="tbk-mb-4 tbk-grid tbk-grid-cols-2 tbk-flex-nowrap tbk-items-center md:tbk-mb-7 lg:tbk-grid-cols-4 lg:tbk-flex-row"
            style={{ gap: "16px" }}
          >
            <a href="#modal-pilates" className="md:tbk-mb-2">
              <div className="tb-mg-md-r-2_ tbk-relative tbk-overflow-hidden">
                <div className="tbk-relative tbk-rounded-2xl lg:tbk-h-auto lg:tbk-bg-none">
                  <picture className="js-progressive-image tbk-mr-5 tbk-pr-1">
                    <source
                      srcSet={`${disciplinePilates} 1x, ${disciplinePilates2x} 2x, ${disciplinePilates3x} 3x`}
                      media="(minWidth: 760px)"
                      type="image/png"
                    />
                    <source
                      srcSet={`${disciplinePilates} 1x, ${disciplinePilates2x} 2x, ${disciplinePilates3x} 3x`}
                      type="image/png"
                    />
                    <img
                      className="tbk-inline-block tbk-rounded-lg tbk-object-cover"
                      aria-hidden="true"
                      alt="Pilates"
                      src={disciplinePilates}
                      style={{
                        verticalAlign: "bottom",
                      }}
                    />
                  </picture>
                </div>

                <div className="tbk-text-cta md:tbk-text-h2-black tbk-absolute tbk-top-0 tbk-left-0 tbk-pt-2 tbk-pl-2 tbk-text-basic-white md:tbk-pt-3 md:tbk-pl-3">
                  Pilates
                </div>
              </div>
            </a>
            <a href="#modal-meditation" className="md:tbk-mb-2">
              <div className="tb-mg-md-r-2_ tbk-relative tbk-overflow-hidden">
                <div className="tbk-relative tbk-rounded-2xl lg:tbk-h-auto lg:tbk-bg-none">
                  <picture className="js-progressive-image tbk-mr-5 tbk-pr-1">
                    <source
                      srcSet={`${disciplineMeditation} 1x, ${disciplineMeditation2x} 2x, ${disciplineMeditation3x} 3x`}
                      media="(minWidth: 760px)"
                      type="image/png"
                    />
                    <source
                      srcSet={`${disciplineMeditation} 1x, ${disciplineMeditation2x} 2x, ${disciplineMeditation3x} 3x`}
                      type="image/png"
                    />
                    <img
                      className="tbk-inline-block tbk-rounded-lg tbk-object-cover"
                      aria-hidden="true"
                      alt="Meditation"
                      src={disciplineMeditation}
                      style={{
                        verticalAlign: "bottom",
                      }}
                    />
                  </picture>
                </div>
                <div className="tbk-text-cta md:tbk-text-h2-black tbk-absolute tbk-top-0 tbk-left-0 tbk-pt-2 tbk-pl-2 tbk-text-basic-white md:tbk-pt-3 md:tbk-pl-3">
                  Meditation
                </div>
              </div>
            </a>
            <a href="#modal-yoga" className="md:tbk-mb-2">
              <div className="tb-mg-md-r-2_ tbk-relative tbk-overflow-hidden">
                <div className="tbk-relative tbk-rounded-2xl lg:tbk-h-auto lg:tbk-bg-none">
                  <picture className="js-progressive-image tbk-mr-5 tbk-pr-1">
                    <source
                      srcSet={`${disciplineYoga} 1x, ${disciplineYoga2x} 2x, ${disciplineYoga3x} 3x`}
                      media="(minWidth: 760px)"
                      type="image/png"
                    />
                    <source
                      srcSet={`${disciplineYoga} 1x, ${disciplineYoga2x} 2x, ${disciplineYoga3x} 3x`}
                      type="image/png"
                    />
                    <img
                      className="tbk-inline-block tbk-rounded-lg tbk-object-cover"
                      aria-hidden="true"
                      alt="Yoga"
                      src={disciplineYoga}
                      style={{
                        verticalAlign: "bottom",
                      }}
                    />
                  </picture>
                </div>
                <div className="tbk-text-cta md:tbk-text-h2-black tbk-absolute tbk-top-0 tbk-left-0 tbk-pt-2 tbk-pl-2 tbk-text-basic-white md:tbk-pt-3 md:tbk-pl-3">
                  Yoga
                </div>
              </div>
            </a>
            <a href="#modal-running" className="md:tbk-mb-2">
              <div className="tbk-relative tbk-overflow-hidden">
                <div className="tbk-relative tbk-rounded-2xl lg:tbk-h-auto lg:tbk-bg-none">
                  <picture className="js-progressive-image tbk-mr-5 tbk-pr-1">
                    <source
                      srcSet={`${disciplineRunning} 1x, ${disciplineRunning2x} 2x, ${disciplineRunning3x} 3x`}
                      media="(minWidth: 760px)"
                      type="image/png"
                    />
                    <source
                      srcSet={`${disciplineRunning} 1x, ${disciplineRunning2x} 2x, ${disciplineRunning3x} 3x`}
                      type="image/png"
                    />
                    <img
                      className="tbk-inline-block tbk-rounded-lg tbk-object-cover"
                      aria-hidden="true"
                      alt="Running"
                      src={disciplineRunning}
                      style={{
                        verticalAlign: "bottom",
                      }}
                    />
                  </picture>
                </div>
                <div className="tbk-text-cta md:tbk-text-h2-black tbk-absolute tbk-top-0 tbk-left-0 tbk-pt-2 tbk-pl-2 tbk-text-basic-white md:tbk-pt-3 md:tbk-pl-3">
                  Running
                </div>
              </div>
            </a>
          </div>

          <div className="tbk-mb-4 tbk-flex tbk-justify-center">
            <button
              className="tbk-text-h3-subtitle tbk-inline-flex tbk-items-center tbk-text-coral hover:tbk-text-coral-light"
              onClick={scrollToForm}
            >
              <div className="">Enquire About Our Workshops</div>
              <ArrowRightIcon />
            </button>
          </div>

          <hr />
        </div>
      </section>

      <section className="tbk-relative tbk-bg-basic-white tbk-pt-4 tbk-pb-7 md:tbk-pt-7 md:tbk-pb-7">
        <div className="tbk-container tbk-mx-auto tbk-px-2 lg:tbk-px-2">
          <div className="tbk-mb-4 tbk-items-center md:tbk-mb-7">
            <div className="tbk-flex tbk-grid-cols-2 tbk-flex-wrap tbk-gap-2 lg:tbk-grid lg:tbk-grid-cols-corporate-solutions">
              <div className="tbk-relative tbk-grow tbk-basis-2/5 tbk-overflow-hidden lg:tbk-basis-auto">
                <picture className="js-progressive-image tbk-h-full tbk-w-full  tbk-overflow-hidden tbk-rounded-lg ">
                  <source
                    srcSet={`${solutionsEvents} 1x, ${solutionsEvents2x} 2x`}
                    media="(minWidth: 760px)"
                    type="image/png"
                  />
                  <source
                    srcSet={`${solutionsEvents} 1x, ${solutionsEvents2x} 2x`}
                    type="image/png"
                  />
                  <img
                    className="tbk-inline-block tbk-h-full tbk-w-full tbk-rounded-lg tbk-object-cover"
                    aria-hidden="true"
                    alt="Events"
                    src={solutionsEvents}
                    style={{ verticalAlign: "bottom" }}
                  />
                </picture>
                <div className="tbk-text-cta md:tbk-text-title-bold tbk-absolute tbk-top-1/2 tbk-left-1/2 tbk--translate-y-1/2 tbk--translate-x-1/2 tbk-uppercase tbk-text-basic-white md:tbk-normal-case">
                  Events
                </div>
              </div>
              <div className="tbk-relative tbk-grow tbk-basis-2/5 tbk-overflow-hidden lg:tbk-basis-auto">
                <picture className="js-progressive-image tbk-h-full tbk-w-full tbk-overflow-hidden tbk-rounded-lg ">
                  <source
                    srcSet={`${solutionsHotels} 1x, ${solutionsHotels2x} 2x`}
                    media="(minWidth: 760px)"
                    type="image/png"
                  />
                  <source
                    srcSet={`${solutionsHotels} 1x, ${solutionsHotels2x} 2x`}
                    type="image/png"
                  />
                  <img
                    className="tbk-inline-block tbk-h-full tbk-w-full tbk-rounded-lg tbk-object-cover"
                    aria-hidden="true"
                    alt="Hotels"
                    src={solutionsHotels}
                    style={{ verticalAlign: "bottom" }}
                  />
                </picture>
                <div className="tbk-text-cta md:tbk-text-title-bold tbk-absolute tbk-top-1/2 tbk-left-1/2 tbk--translate-y-1/2 tbk--translate-x-1/2 tbk-uppercase tbk-text-basic-white md:tbk-normal-case">
                  Hotels
                </div>
              </div>
              <div className="tbk-relative tbk-grow tbk-basis-2/5 tbk-overflow-hidden lg:tbk-basis-auto">
                <picture className="js-progressive-image tbk-h-full tbk-w-full tbk-overflow-hidden tbk-rounded-lg ">
                  <source
                    srcSet={`${solutionsHospitality} 1x, ${solutionsHospitality2x} 2x`}
                    media="(minWidth: 760px)"
                    type="image/png"
                  />
                  <source
                    srcSet={`${solutionsHospitality} 1x, ${solutionsHospitality2x} 2x`}
                    type="image/png"
                  />
                  <img
                    className="tbk-inline-block tbk-h-full tbk-w-full tbk-rounded-lg tbk-object-cover"
                    aria-hidden="true"
                    alt="Hospitality"
                    src={solutionsHospitality}
                    style={{ verticalAlign: "bottom" }}
                  />
                </picture>
                <div className="tbk-text-cta md:tbk-text-title-bold tbk-absolute tbk-top-1/2 tbk-left-1/2 tbk--translate-y-1/2 tbk--translate-x-1/2 tbk-uppercase tbk-text-basic-white md:tbk-normal-case">
                  Hospitality
                </div>
              </div>
              <div className="tbk-relative tbk-grow tbk-basis-2/5 tbk-overflow-hidden lg:tbk-basis-auto">
                <picture className="js-progressive-image tbk-h-full tbk-w-full tbk-overflow-hidden tbk-rounded-lg ">
                  <source
                    srcSet={`${solutionsCareHomes} 1x, ${solutionsCareHomes2x} 2x`}
                    media="(minWidth: 760px)"
                    type="image/png"
                  />
                  <source
                    srcSet={`${solutionsCareHomes} 1x, ${solutionsCareHomes2x} 2x`}
                    type="image/png"
                  />
                  <img
                    className="tbk-inline-block tbk-h-full tbk-w-full tbk-rounded-lg tbk-object-cover"
                    aria-hidden="true"
                    alt="Care Homes"
                    src={solutionsCareHomes}
                    style={{ verticalAlign: "bottom" }}
                  />
                </picture>
                <div className="tbk-text-cta md:tbk-text-title-bold tbk-absolute tbk-top-1/2  tbk-left-1/2 tbk--translate-y-1/2 tbk--translate-x-1/2 tbk-whitespace-nowrap tbk-uppercase tbk-text-basic-white md:tbk-normal-case">
                  Care Homes
                </div>
              </div>
              <div className="tbk-relative tbk-basis-full tbk-overflow-hidden md:tbk-basis-auto">
                <div className={"tbk-pt-[44.692737430167598%]"}>
                  <picture className="js-progressive-image tbk-absolute tbk-top-0 tbk-left-0 tbk-h-full tbk-w-full tbk-overflow-hidden tbk-rounded-lg">
                    <source
                      srcSet={`${solutionsCoWorkingSpaces} 1x, ${solutionsCoWorkingSpaces2x} 2x`}
                      media="(minWidth: 760px)"
                      type="image/png"
                    />
                    <source
                      srcSet={`${solutionsCoWorkingSpaces} 1x, ${solutionsCoWorkingSpaces2x} 2x`}
                      type="image/png"
                    />
                    <img
                      className="tbk-inline-block tbk-h-full tbk-w-full tbk-object-cover"
                      aria-hidden="true"
                      alt="Co-Working Spaces"
                      src={solutionsCoWorkingSpaces}
                      style={{ verticalAlign: "bottom" }}
                    />
                  </picture>
                </div>
                <div className="tbk-text-cta md:tbk-text-title-bold tbk-absolute tbk-top-1/2 tbk-left-1/2 tbk--translate-y-1/2 tbk--translate-x-1/2 tbk-text-center tbk-uppercase tbk-text-basic-white md:tbk-normal-case">
                  <span className="tbk-whitespace-nowrap">Co-Working</span>{" "}
                  Spaces
                </div>
              </div>
            </div>
          </div>

          <div className="tbk-flex tbk-justify-center">
            <div className="tbk-w-126">
              <p className="tbk-text-main tbk-mb-0 tbk-text-center tbk-text-primary">
                TruBe specialises in delivering customised fitness and wellness
                solutions across diverse sectors. From energising events to
                promoting well-being in co-working spaces, enhancing corporate
                hospitality experiences, and providing tailored care for
                residents in care homes, TruBe offers versatile and expert
                services for a wide range of environments.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section
        className="how-it-works-section background-fill_ tbk-mb-0 tbk-hidden tbk-bg-grey-light tbk-pt-7 md:tbk-pt-7"
        style={{ overflow: "hidden" }}
      >
        <div className="tbk-container tbk-px-1 lg:tbk-px-5">
          <div className="row tb-gutter-none tbk-items-center">
            <div className="col-8 tbk-mb-7">
              <h2 className="tbk-text-headline tbk-text-md-h1-headline tbk-c-grey-main text-uppercase tbk-mt-0 tbk-text-center md:tbk-text-left">
                How it works
              </h2>
            </div>
          </div>
          <div className="row u-flex-stretch tbk-items-center">
            <div className="col-xs-8 col-md-4 tbk-mb-4 md:tbk-mb-7">
              <div className="how-it-works-box with-number-label with-number-label-1 tbk-h-full">
                <div className="how-it-works-box-content tb-shadow-box tbk-h-full tbk-rounded-lg tbk-bg-basic-white  tbk-p-2">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M29.25 10L33 13.75L16.75 30L8 21.25L11.75 17.5L16.75 22.5L29.25 10Z"
                      fill="#E94E32"
                    />
                  </svg>

                  <p className="tbk-text-main">
                    Employees sign up for TruBe classes as an employee perk or
                    salary sacrifice
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xs-8 col-md-4 tbk-mb-4 md:tbk-mb-7">
              <div className="how-it-works-box with-number-label with-number-label-2 tbk-h-full">
                <div className="how-it-works-box-content tb-shadow-box tbk-h-full tbk-rounded-lg tbk-bg-basic-white  tbk-p-2">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M31.9362 17.9288C31.8066 17.6223 31.5012 17.4224 31.1625 17.4224H22.2705L23.9162 6.94508C23.9713 6.59448 23.7901 6.24897 23.467 6.08862C23.1439 5.92822 22.7523 5.98953 22.4962 6.24033L7.24534 21.1772C7.0058 21.4118 6.93416 21.7647 7.06376 22.0712C7.19341 22.3777 7.49884 22.5776 7.83754 22.5776H16.7294L15.0837 33.0549C15.0286 33.4055 15.2099 33.751 15.5329 33.9114C15.856 34.0718 16.2477 34.0105 16.5037 33.7597L31.7546 18.8228C31.9942 18.5881 32.0658 18.2353 31.9362 17.9288Z"
                      fill="#E94E32"
                    />
                  </svg>
                  <p className="tbk-text-main">Employees have access to:</p>
                  <ul>
                    <li className="tbk-text-main">8 different disciplines</li>
                    <li className="tbk-text-main">5* rated trainers</li>
                    <li className="tbk-text-main">Classes on demand</li>
                    <li className="tbk-text-main">Well-being newsletters</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-xs-8 col-md-4 tbk-mb-4 md:tbk-mb-7">
              <div className="how-it-works-box with-number-label with-number-label-3 tbk-relative tbk-h-full">
                <div className="how-it-works-box-content tb-shadow-box tbk-h-full tbk-rounded-lg tbk-bg-basic-white  tbk-p-2">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#0047adc6)">
                      <path
                        d="M11.5685 10.4058C13.801 10.0518 15.3248 7.95584 14.9705 5.72192C14.7455 4.3032 13.8149 3.17166 12.5931 2.6259C12.7891 2.4449 13.0175 2.26967 13.2891 2.10586C13.4182 2.02802 13.4905 1.88222 13.4739 1.73217C13.4573 1.58225 13.355 1.45558 13.2119 1.40785C12.5201 1.1772 11.74 1.29314 11.0273 1.55062C11.115 1.29754 11.2341 1.03415 11.3971 0.760588C11.4744 0.631026 11.4693 0.468316 11.384 0.34398C11.2988 0.219507 11.1488 0.155964 11 0.181271C9.52519 0.432418 8.4074 2.14492 8.0095 3.12668C7.93867 3.3015 7.88778 3.4803 7.85655 3.65869C7.07918 4.5421 6.68623 5.75204 6.88484 7.00392C7.239 9.23812 9.33634 10.7599 11.5685 10.4058Z"
                        fill="#E94E32"
                      />
                      <path
                        d="M39.5456 9.66161C38.97 9.12686 38.0695 9.15959 37.5345 9.73561L32.7508 14.8845C32.3514 14.6001 31.8897 14.4056 31.3961 14.3272L29.313 13.997C28.8139 13.9179 28.3086 13.9597 27.8363 14.1107L24.8772 7.72863C24.5466 7.01562 23.7006 6.70561 22.9877 7.03612C22.2747 7.36663 21.9647 8.21277 22.2952 8.92564L25.7238 16.3207C25.6495 16.5933 25.7443 16.0366 24.5319 23.9736L22.6602 26.2753L22.7153 26.343C23.2338 26.9806 23.5167 27.7774 23.5167 28.599V35.4546C23.5399 35.4554 23.5628 35.458 23.5863 35.458C24.5687 35.458 25.3651 34.6616 25.3651 33.6792V28.5876L27.3487 26.1482L29.1113 26.4848L28.648 29.4061C28.6323 29.5057 28.6249 29.6064 28.6263 29.7072L28.707 36.0827C28.7194 37.0573 29.5132 37.8391 30.4853 37.8388C30.4928 37.8388 30.5006 37.8388 30.5083 37.8387C31.4906 37.8263 32.2767 37.0199 32.2644 36.0374L32.1857 29.8135C32.2916 29.1458 34.0819 17.8876 34.0931 17.6212L39.6198 11.6724C40.1543 11.0968 40.1213 10.1966 39.5456 9.66161Z"
                        fill="#E94E32"
                      />
                      <path
                        d="M30.561 12.799C32.4206 13.0941 34.1681 11.8262 34.4632 9.96503C34.6286 8.92193 34.3012 7.9139 33.6535 7.17793C33.6275 7.02939 33.585 6.88029 33.526 6.73478C33.1946 5.9171 32.2632 4.49027 31.0346 4.28093C30.9107 4.25989 30.7857 4.3127 30.7147 4.41641C30.6436 4.52011 30.6395 4.65545 30.7039 4.76342C30.8398 4.9916 30.9392 5.21125 31.0122 5.42237C30.4185 5.20767 29.7685 5.11043 29.192 5.30271C29.0728 5.3426 28.9875 5.44809 28.9736 5.57298C28.9599 5.698 29.0201 5.81945 29.1277 5.88437C29.3539 6.02081 29.544 6.16688 29.7074 6.31762C28.6896 6.77205 27.9141 7.71475 27.7268 8.89676C27.4317 10.7581 28.7012 12.5042 30.561 12.799Z"
                        fill="#E94E32"
                      />
                      <path
                        d="M18.8056 23.8187C17.3757 14.631 17.3757 14.631 17.3757 14.631L21.4902 5.75654C21.8872 4.90063 21.515 3.88531 20.6591 3.48851C19.8036 3.09171 18.7879 3.46348 18.391 4.31966L14.8394 11.9805C14.2723 11.7991 13.6656 11.749 13.0663 11.844L10.5661 12.2404C9.97363 12.3345 9.41796 12.5656 8.93836 12.9074L3.19815 6.72867C2.55584 6.03753 1.47533 5.99792 0.784052 6.63982C0.0930528 7.28199 0.0533039 8.36278 0.695339 9.05392L7.32929 16.1944C7.32929 16.1944 8.32081 22.6443 9.61877 30.8293L9.52415 38.3001C9.50929 39.4791 10.453 40.4471 11.6321 40.4621C11.6412 40.4622 11.6505 40.4622 11.6596 40.4622C12.8261 40.4622 13.7792 39.524 13.7941 38.3541L13.8909 30.7014C13.8925 30.5804 13.8836 30.4595 13.8648 30.34L13.3087 26.8334L15.4246 26.4293L17.8054 29.3574V35.4689C17.8054 36.6481 18.7613 37.604 19.9404 37.604C21.1196 37.604 22.0755 36.6481 22.0755 35.4689V28.599C22.0755 28.1084 21.9066 27.6326 21.5971 27.2519L18.8056 23.8187Z"
                        fill="#E94E32"
                      />
                    </g>
                    <defs>
                      <clipPath id="0047adc6">
                        <rect width="40" height="40" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                  <p className="tbk-text-main">Your Teams Benefits:</p>
                  <ul>
                    <li className="tbk-text-main">
                      Improved job efficiency – Better engagement
                    </li>
                    <li className="tbk-text-main">
                      Improved Job retention – Happier Employees
                    </li>
                    <li className="tbk-text-main">
                      Less Sick days – Healthier body and mind
                    </li>
                    <li className="tbk-text-main">
                      Empowered – More motivated and driven
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="section-we-provide tbk-pt-7_ md:tbk-pt-7_ background-fill grey background-fill-sm tbk-mb-0 tbk-hidden tbk-pb-7 md:tbk-pb-7 "
        style={{ overflow: "hidden" }}
      >
        <div className="tbk-container lg:tbk-px-5">
          <div className="row tbk-items-center">
            <div className="col-12 tbk-mb-7_">
              <h2 className="tb-mg-md-b-5 tbk-text-headline tbk-text-md-h1-headline tbk-c-grey-main text-uppercase tbk-mt-0 tbk-mb-1 tbk-text-center md:tbk-text-left">
                We provide
              </h2>
              <p className="tbk-text-main hidden-md hidden-lg tbk-mb-4 tbk-text-center tbk-text-basic-trueblack">
                This enables us and you to provide a tailored solution that is
                best for your employees:
              </p>
            </div>
          </div>
          <div className="u-d-lg-flex u-flex-space-evenly u-flex-stretch tb-mg-md-b-5 tbk-relative tbk-items-center">
            <div className="we-provide-card tb-mg-b-2 tb-mg-lg-b-0 lg:tbk-mr-2">
              <div className="tbk-h-full">
                <div className="u-d-lg-block tb-shadow-box tbk-flex tbk-h-full tbk-rounded-lg tbk-bg-basic-white tbk-p-2">
                  <svg
                    width="64"
                    height="64"
                    viewBox="0 0 64 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="tbk-m-2 tbk-shrink-0 md:tbk-mb-2"
                  >
                    <path
                      d="M37.2755 54.4178H35.2598V44.5407C35.2598 44.2734 35.1536 44.017 34.9646 43.828C34.7756 43.639 34.5192 43.5328 34.2519 43.5328C33.9846 43.5328 33.7282 43.639 33.5392 43.828C33.3502 44.017 33.244 44.2734 33.244 44.5407V54.4178H7.03936V34.2604H15.4249C15.6922 34.2604 15.9485 34.1542 16.1375 33.9652C16.3265 33.7762 16.4327 33.5198 16.4327 33.2525C16.4327 32.9852 16.3265 32.7288 16.1375 32.5398C15.9485 32.3508 15.6922 32.2446 15.4249 32.2446H6.03149C5.76418 32.2446 5.50783 32.3508 5.31881 32.5398C5.1298 32.7288 5.02362 32.9852 5.02362 33.2525V54.4178H3.00787C2.74057 54.4178 2.48421 54.524 2.2952 54.713C2.10619 54.902 2 55.1584 2 55.4257V57.4414C2 58.7779 2.53093 60.0597 3.47599 61.0048C4.42106 61.9498 5.70284 62.4808 7.03936 62.4808H33.244C34.5805 62.4808 35.8623 61.9498 36.8074 61.0048C37.7525 60.0597 38.2834 58.7779 38.2834 57.4414V55.4257C38.2834 55.1584 38.1772 54.902 37.9882 54.713C37.7992 54.524 37.5428 54.4178 37.2755 54.4178ZM36.2676 57.4414C36.2676 58.2433 35.9491 59.0124 35.382 59.5794C34.815 60.1465 34.0459 60.465 33.244 60.465H31.2283V59.4572C31.2283 59.1899 31.1221 58.9335 30.9331 58.7445C30.7441 58.5555 30.4877 58.4493 30.2204 58.4493C29.9531 58.4493 29.6967 58.5555 29.5077 58.7445C29.3187 58.9335 29.2125 59.1899 29.2125 59.4572V60.465H11.0708V59.4572C11.0708 59.1899 10.9647 58.9335 10.7756 58.7445C10.5866 58.5555 10.3303 58.4493 10.063 58.4493C9.79567 58.4493 9.53931 58.5555 9.3503 58.7445C9.16129 58.9335 9.0551 59.1899 9.0551 59.4572V60.465H7.03936C6.23745 60.465 5.46838 60.1465 4.90134 59.5794C4.3343 59.0124 4.01574 58.2433 4.01574 57.4414V56.4335H36.2676V57.4414Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M54.409 8.05627H56.4248C56.6921 8.05627 56.9485 7.95008 57.1375 7.76107C57.3265 7.57206 57.4327 7.3157 57.4327 7.0484C57.4327 6.78109 57.3265 6.52474 57.1375 6.33573C56.9485 6.14671 56.6921 6.04053 56.4248 6.04053H54.409C53.6071 6.04053 52.8381 6.35909 52.271 6.92612C51.704 7.49316 51.3854 8.26223 51.3854 9.06414V10.072H50.3776C50.1103 10.072 49.8539 10.1782 49.6649 10.3672C49.4759 10.5562 49.3697 10.8126 49.3697 11.0799C49.3697 11.3472 49.4759 11.6035 49.6649 11.7926C49.8539 11.9816 50.1103 12.0878 50.3776 12.0878H51.3854V15.1114C51.3854 15.3787 51.4916 15.635 51.6806 15.824C51.8696 16.0131 52.126 16.1192 52.3933 16.1192C52.6606 16.1192 52.917 16.0131 53.106 15.824C53.295 15.635 53.4012 15.3787 53.4012 15.1114V12.0878H54.409C54.6764 12.0878 54.9327 11.9816 55.1217 11.7926C55.3107 11.6035 55.4169 11.3472 55.4169 11.0799C55.4169 10.8126 55.3107 10.5562 55.1217 10.3672C54.9327 10.1782 54.6764 10.072 54.409 10.072H53.4012V9.06414C53.4012 8.79684 53.5074 8.54048 53.6964 8.35147C53.8854 8.16246 54.1417 8.05627 54.409 8.05627Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M59.448 2.0083H47.3535C46.5516 2.0083 45.7825 2.32686 45.2155 2.8939C44.6485 3.46094 44.3299 4.23 44.3299 5.03192V7.04766C44.3299 7.31496 44.4361 7.57132 44.6251 7.76033C44.8141 7.94935 45.0705 8.05553 45.3378 8.05553C45.6051 8.05553 45.8614 7.94935 46.0504 7.76033C46.2395 7.57132 46.3456 7.31496 46.3456 7.04766V5.03192C46.3456 4.76461 46.4518 4.50826 46.6408 4.31924C46.8298 4.13023 47.0862 4.02404 47.3535 4.02404H59.448C59.7153 4.02404 59.9716 4.13023 60.1606 4.31924C60.3497 4.50826 60.4558 4.76461 60.4558 5.03192V17.1264C60.4558 17.3937 60.3497 17.65 60.1606 17.8391C59.9716 18.0281 59.7153 18.1342 59.448 18.1342H47.3535C47.0862 18.1342 46.8298 18.0281 46.6408 17.8391C46.4518 17.65 46.3456 17.3937 46.3456 17.1264V11.0791C46.3456 10.8118 46.2395 10.5555 46.0504 10.3665C45.8614 10.1775 45.6051 10.0713 45.3378 10.0713C45.0705 10.0713 44.8141 10.1775 44.6251 10.3665C44.4361 10.5555 44.3299 10.8118 44.3299 11.0791V17.1264C44.3299 17.9283 44.6485 18.6974 45.2155 19.2644C45.7825 19.8314 46.5516 20.15 47.3535 20.15H59.448C60.2499 20.15 61.019 19.8314 61.586 19.2644C62.153 18.6974 62.4716 17.9283 62.4716 17.1264V5.03192C62.4716 4.23 62.153 3.46094 61.586 2.8939C61.019 2.32686 60.2499 2.0083 59.448 2.0083Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M49.3697 42.3225C49.3697 43.1199 49.6061 43.8993 50.0491 44.5623C50.4921 45.2253 51.1217 45.742 51.8584 46.0471C52.5951 46.3522 53.4056 46.4321 54.1877 46.2765C54.9697 46.121 55.6881 45.737 56.2519 45.1732C56.8157 44.6094 57.1996 43.891 57.3552 43.109C57.5108 42.327 57.4309 41.5164 57.1258 40.7797C56.8207 40.0431 56.3039 39.4134 55.641 38.9704C54.978 38.5275 54.1985 38.291 53.4012 38.291C52.332 38.291 51.3065 38.7158 50.5505 39.4718C49.7944 40.2279 49.3697 41.2533 49.3697 42.3225ZM55.4169 42.3225C55.4169 42.7212 55.2987 43.1109 55.0772 43.4424C54.8557 43.7739 54.5409 44.0322 54.1726 44.1848C53.8042 44.3374 53.3989 44.3773 53.0079 44.2995C52.6169 44.2217 52.2577 44.0298 51.9758 43.7478C51.6939 43.4659 51.5019 43.1068 51.4242 42.7158C51.3464 42.3247 51.3863 41.9194 51.5389 41.5511C51.6914 41.1828 51.9498 40.868 52.2813 40.6465C52.6128 40.425 53.0025 40.3068 53.4012 40.3068C53.9358 40.3068 54.4485 40.5191 54.8265 40.8972C55.2045 41.2752 55.4169 41.7879 55.4169 42.3225Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M59.448 33.251H47.3535C46.5516 33.251 45.7825 33.5695 45.2155 34.1366C44.6485 34.7036 44.3299 35.4727 44.3299 36.2746V48.3691C44.3299 49.171 44.6485 49.94 45.2155 50.5071C45.7825 51.0741 46.5516 51.3927 47.3535 51.3927H59.448C60.2499 51.3927 61.019 51.0741 61.586 50.5071C62.153 49.94 62.4716 49.171 62.4716 48.3691V46.3533C62.4716 46.086 62.3654 45.8296 62.1764 45.6406C61.9874 45.4516 61.731 45.3454 61.4637 45.3454C61.1964 45.3454 60.9401 45.4516 60.751 45.6406C60.562 45.8296 60.4558 46.086 60.4558 46.3533V48.3691C60.4558 48.6364 60.3497 48.8927 60.1606 49.0817C59.9716 49.2707 59.7153 49.3769 59.448 49.3769H47.3535C47.0862 49.3769 46.8298 49.2707 46.6408 49.0817C46.4518 48.8927 46.3456 48.6364 46.3456 48.3691V36.2746C46.3456 36.0073 46.4518 35.7509 46.6408 35.5619C46.8298 35.3729 47.0862 35.2667 47.3535 35.2667H59.448C59.7153 35.2667 59.9716 35.3729 60.1606 35.5619C60.3497 35.7509 60.4558 36.0073 60.4558 36.2746V42.3218C60.4558 42.5891 60.562 42.8455 60.751 43.0345C60.9401 43.2235 61.1964 43.3297 61.4637 43.3297C61.731 43.3297 61.9874 43.2235 62.1764 43.0345C62.3654 42.8455 62.4716 42.5891 62.4716 42.3218V36.2746C62.4716 35.4727 62.153 34.7036 61.586 34.1366C61.019 33.5695 60.2499 33.251 59.448 33.251Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M24.6489 13.9507C24.8093 14.0501 24.9943 14.1025 25.183 14.1019C25.3408 14.101 25.4962 14.063 25.6366 13.991L31.6838 10.9674C31.8489 10.8829 31.9875 10.7544 32.0842 10.5961C32.1809 10.4378 32.2321 10.2559 32.2321 10.0704C32.2321 9.88493 32.1809 9.70304 32.0842 9.54477C31.9875 9.3865 31.8489 9.258 31.6838 9.17342L25.6366 6.14981C25.4832 6.07249 25.3125 6.03568 25.1409 6.04288C24.9692 6.05007 24.8022 6.10102 24.6558 6.19089C24.5094 6.28077 24.3884 6.40658 24.3042 6.55638C24.2201 6.70619 24.1757 6.87501 24.1752 7.04681V13.094C24.1748 13.2653 24.2181 13.4339 24.301 13.5838C24.3839 13.7337 24.5036 13.86 24.6489 13.9507ZM26.1909 8.67957L28.9726 10.0704L26.1909 11.4613V8.67957Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M27.1966 19.1417C28.9906 19.1417 30.7444 18.6097 32.2361 17.613C33.7278 16.6163 34.8904 15.1996 35.5769 13.5421C36.2635 11.8846 36.4431 10.0608 36.0931 8.30122C35.7431 6.54164 34.8792 4.92537 33.6106 3.65679C32.3421 2.38821 30.7258 1.5243 28.9662 1.1743C27.2066 0.824297 25.3828 1.00393 23.7253 1.69048C22.0678 2.37703 20.6512 3.53966 19.6544 5.03136C18.6577 6.52305 18.1257 8.27681 18.1257 10.0708C18.1257 12.4766 19.0814 14.7838 20.7825 16.4849C22.4836 18.186 24.7908 19.1417 27.1966 19.1417ZM27.1966 3.01575C28.5919 3.01575 29.956 3.42952 31.1162 4.20475C32.2764 4.97997 33.1807 6.08183 33.7146 7.37098C34.2486 8.66013 34.3883 10.0787 34.1161 11.4472C33.8439 12.8158 33.172 14.0729 32.1853 15.0596C31.1986 16.0462 29.9415 16.7182 28.573 16.9904C27.2044 17.2626 25.7859 17.1229 24.4967 16.5889C23.2076 16.0549 22.1057 15.1507 21.3305 13.9905C20.5552 12.8302 20.1415 11.4662 20.1415 10.0708C20.1415 8.19972 20.8848 6.40523 22.2079 5.08214C23.531 3.75905 25.3254 3.01575 27.1966 3.01575Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M37.2755 23.1732C37.4319 23.1732 37.5862 23.1368 37.7262 23.0668C37.8661 22.9968 37.9879 22.8952 38.0817 22.7701L41.1054 18.7386C41.2657 18.5247 41.3346 18.2559 41.2968 17.9913C41.259 17.7267 41.1176 17.4879 40.9038 17.3276C40.6899 17.1672 40.4212 17.0983 40.1565 17.1361C39.8919 17.1739 39.6532 17.3153 39.4928 17.5291L36.4692 21.5606C36.3088 21.7745 36.2399 22.0433 36.2777 22.3079C36.3155 22.5725 36.4569 22.8113 36.6707 22.9716C36.8452 23.1025 37.0574 23.1732 37.2755 23.1732Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M39.4917 26.8013C39.5856 26.9264 39.7074 27.028 39.8473 27.098C39.9873 27.168 40.1416 27.2044 40.298 27.2044C40.5161 27.2044 40.7283 27.1337 40.9028 27.0028L44.9342 23.9792C45.1481 23.8188 45.2895 23.5801 45.3273 23.3155C45.3651 23.0508 45.2962 22.782 45.1358 22.5682C44.9754 22.3543 44.7367 22.213 44.4721 22.1752C44.2074 22.1374 43.9386 22.2062 43.7248 22.3666L39.6933 25.3902C39.4795 25.5506 39.3381 25.7894 39.3003 26.054C39.2625 26.3186 39.3314 26.5874 39.4917 26.8013Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M49.3714 29.019C49.3474 28.8854 49.2967 28.758 49.2223 28.6444C49.1479 28.5309 49.0513 28.4335 48.9384 28.3582C48.8254 28.2829 48.6984 28.2312 48.565 28.2062C48.4316 28.1812 48.2945 28.1834 48.1619 28.2127L43.1226 29.2206C42.9902 29.2338 42.8618 29.273 42.7445 29.3359C42.6273 29.3987 42.5236 29.4841 42.4394 29.587C42.2693 29.7949 42.1887 30.0619 42.2155 30.3292C42.2422 30.5965 42.374 30.8423 42.5819 31.0124C42.7899 31.1825 43.0568 31.263 43.3241 31.2363H43.5257L48.5651 30.2284C48.6987 30.2045 48.8261 30.1538 48.9396 30.0794C49.0532 30.005 49.1505 29.9084 49.2258 29.7954C49.3011 29.6825 49.3528 29.5555 49.3778 29.4221C49.4028 29.2886 49.4006 29.1515 49.3714 29.019Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M3.00787 29.2203H15.1023C15.3696 29.2203 15.626 29.1141 15.815 28.9251C16.004 28.7361 16.1102 28.4797 16.1102 28.2124V12.0865C16.1102 11.8192 16.004 11.5628 15.815 11.3738C15.626 11.1848 15.3696 11.0786 15.1023 11.0786H3.00787C2.74057 11.0786 2.48421 11.1848 2.2952 11.3738C2.10619 11.5628 2 11.8192 2 12.0865V28.2124C2 28.4797 2.10619 28.7361 2.2952 28.9251C2.48421 29.1141 2.74057 29.2203 3.00787 29.2203ZM4.01574 13.0944H14.0945V27.2046H4.01574V13.0944Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M11.0709 15.1108H9.05517C8.78787 15.1108 8.53151 15.217 8.3425 15.406C8.15349 15.5951 8.0473 15.8514 8.0473 16.1187C8.0473 16.386 8.15349 16.6424 8.3425 16.8314C8.53151 17.0204 8.78787 17.1266 9.05517 17.1266H11.0709C11.3382 17.1266 11.5946 17.0204 11.7836 16.8314C11.9726 16.6424 12.0788 16.386 12.0788 16.1187C12.0788 15.8514 11.9726 15.5951 11.7836 15.406C11.5946 15.217 11.3382 15.1108 11.0709 15.1108Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M11.0705 19.1421H7.03906C6.77176 19.1421 6.5154 19.2483 6.32639 19.4373C6.13738 19.6263 6.03119 19.8827 6.03119 20.15C6.03119 20.4173 6.13738 20.6736 6.32639 20.8626C6.5154 21.0516 6.77176 21.1578 7.03906 21.1578H11.0705C11.3379 21.1578 11.5942 21.0516 11.7832 20.8626C11.9722 20.6736 12.0784 20.4173 12.0784 20.15C12.0784 19.8827 11.9722 19.6263 11.7832 19.4373C11.5942 19.2483 11.3379 19.1421 11.0705 19.1421Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M11.0705 23.1724H7.03906C6.77176 23.1724 6.5154 23.2785 6.32639 23.4676C6.13738 23.6566 6.03119 23.9129 6.03119 24.1802C6.03119 24.4475 6.13738 24.7039 6.32639 24.8929C6.5154 25.0819 6.77176 25.1881 7.03906 25.1881H11.0705C11.3379 25.1881 11.5942 25.0819 11.7832 24.8929C11.9722 24.7039 12.0784 24.4475 12.0784 24.1802C12.0784 23.9129 11.9722 23.6566 11.7832 23.4676C11.5942 23.2785 11.3379 23.1724 11.0705 23.1724Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M36.3885 28.9174C36.3223 28.8023 36.2341 28.7013 36.1289 28.6202C36.0237 28.5392 35.9035 28.4796 35.7753 28.445C35.6471 28.4104 35.5133 28.4014 35.3816 28.4184C35.2499 28.4355 35.1229 28.4784 35.0077 28.5445C34.8926 28.6107 34.7916 28.6989 34.7105 28.8041C34.6294 28.9093 34.5699 29.0295 34.5353 29.1577C34.5006 29.2859 34.4916 29.4197 34.5087 29.5514C34.5258 29.6831 34.5686 29.8102 34.6348 29.9253L39.0795 37.6154L22.9536 43.6626C22.9536 43.6626 22.9536 43.6626 22.883 43.6626H22.8024L20.1819 45.1744L18.4383 46.1823C18.2087 46.315 17.9553 46.4011 17.6924 46.4357C17.4295 46.4703 17.1624 46.4527 16.9063 46.3839C16.3919 46.2449 15.9534 45.9079 15.6868 45.4465L13.6711 41.9593C13.4339 41.5031 13.3801 40.9734 13.5206 40.4788C13.6611 39.9842 13.9854 39.5619 14.427 39.2985L17.9142 37.2828L20.4339 41.6469C20.5227 41.8007 20.6505 41.9283 20.8045 42.0168C20.9585 42.1053 21.1331 42.1515 21.3107 42.1508C21.488 42.1515 21.6623 42.1054 21.8161 42.0173C21.9698 41.9291 22.0976 41.8019 22.1866 41.6486C22.2755 41.4953 22.3224 41.3212 22.3226 41.1439C22.3228 40.9667 22.2762 40.7925 22.1876 40.639L19.5873 36.1439L32.2361 25.7124L32.6493 26.428C32.7155 26.5431 32.8037 26.6441 32.9089 26.7252C33.0141 26.8063 33.1342 26.8658 33.2624 26.9004C33.3907 26.9351 33.5244 26.9441 33.6561 26.927C33.7879 26.9099 33.9149 26.8671 34.0301 26.8009C34.1452 26.7347 34.2462 26.6465 34.3273 26.5413C34.4083 26.4361 34.4679 26.316 34.5025 26.1878C34.5371 26.0595 34.5462 25.9258 34.5291 25.794C34.512 25.6623 34.4692 25.5353 34.403 25.4201L33.3951 23.6765C33.3212 23.5502 33.2208 23.4416 33.1007 23.358C32.9806 23.2745 32.8438 23.2181 32.6997 23.1927C32.5548 23.1654 32.4057 23.1702 32.2629 23.2068C32.1202 23.2434 31.9871 23.3108 31.8732 23.4044L17.763 35.0352L13.4695 37.5146C12.699 37.9634 12.099 38.655 11.7634 39.4811C11.4279 40.3072 11.3757 41.2213 11.615 42.0802L10.6071 42.6547C10.0878 42.9529 9.66878 43.3986 9.4031 43.9353C9.13742 44.472 9.03709 45.0755 9.11482 45.6692C9.19255 46.263 9.44484 46.8203 9.83971 47.2705C10.2346 47.7207 10.7542 48.0435 11.3328 48.198C11.5893 48.266 11.8536 48.2999 12.1189 48.2988C12.6492 48.2966 13.1698 48.1578 13.6307 47.8957L14.6386 47.3212C15.1228 47.8213 15.7317 48.1832 16.4024 48.3694C16.7468 48.4657 17.103 48.5132 17.4607 48.5105C18.1691 48.5121 18.8651 48.3242 19.4764 47.9662L20.3532 47.4623L22.369 50.9596C22.7696 51.6522 23.4284 52.1578 24.201 52.3656C24.9737 52.5734 25.7972 52.4665 26.4912 52.0683C26.8355 51.8699 27.1373 51.6056 27.3794 51.2905C27.6214 50.9754 27.799 50.6157 27.902 50.2319C28.005 49.8481 28.0313 49.4478 27.9794 49.0539C27.9276 48.6599 27.7986 48.2801 27.5998 47.936L25.7655 44.741L40.8836 39.0667C41.0207 39.0152 41.1449 38.9344 41.2476 38.8299C41.3503 38.7255 41.429 38.5999 41.4782 38.462C41.5273 38.3257 41.5464 38.1804 41.5342 38.036C41.522 37.8917 41.4789 37.7516 41.4077 37.6255L36.3885 28.9174ZM12.5826 46.142C12.4678 46.2083 12.341 46.2514 12.2096 46.2687C12.0782 46.286 11.9446 46.2772 11.8166 46.2428C11.5584 46.1757 11.3373 46.009 11.2018 45.7791C11.1354 45.6644 11.0924 45.5376 11.0751 45.4062C11.0578 45.2747 11.0666 45.1412 11.101 45.0132C11.1354 44.8845 11.195 44.7639 11.2763 44.6583C11.3576 44.5528 11.459 44.4644 11.5747 44.3984L12.4515 43.8944L13.4594 45.638L12.5826 46.142ZM25.8461 48.964C25.9125 49.0788 25.9556 49.2055 25.9729 49.337C25.9901 49.4684 25.9813 49.602 25.9469 49.73C25.8751 49.9862 25.7048 50.2036 25.4732 50.3347C25.243 50.467 24.9699 50.503 24.7133 50.4351C24.4566 50.3672 24.2372 50.2007 24.1025 49.9719L22.0868 46.4746L23.7599 45.5171H23.8405L25.8461 48.964Z"
                      fill="#E94E32"
                    />
                  </svg>

                  <p className="tbk-text-main">
                    Marketing materials so that you can promote the employee
                    benefit easily
                  </p>
                </div>
              </div>
            </div>
            <div className="we-provide-card tb-mg-b-2 tb-mg-lg-b-0 lg:tbk-mr-2">
              <div className="tbk-h-full">
                <div className="u-d-lg-block tb-shadow-box tbk-flex tbk-h-full tbk-rounded-lg tbk-bg-basic-white tbk-p-2">
                  <svg
                    width="64"
                    height="64"
                    viewBox="0 0 64 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="tbk-m-2 tbk-shrink-0 md:tbk-mb-2"
                  >
                    <path
                      d="M57.4408 34.7939V15.0296C60.8545 14.5377 63.488 11.6018 63.488 8.0551C63.488 4.16572 60.3233 1 56.4329 1C52.5426 1 49.3778 4.16572 49.3778 8.0551H1V48.37H31.2875C31.8116 56.7917 38.8113 63.488 47.3621 63.488C56.2535 63.488 63.488 56.2535 63.488 47.3621C63.488 42.2834 61.1226 37.752 57.4408 34.7939ZM56.4329 3.01574C59.2116 3.01574 61.4723 5.2764 61.4723 8.0551C61.4723 10.8338 59.2116 13.0945 56.4329 13.0945C53.6542 13.0945 51.3936 10.8338 51.3936 8.0551C51.3936 5.2764 53.6542 3.01574 56.4329 3.01574ZM3.01574 10.0708H49.6752C49.916 10.8751 50.299 11.6159 50.7909 12.273L44.6267 18.4372C44.2316 18.2477 43.7962 18.1338 43.3306 18.1338C42.865 18.1338 42.4296 18.2477 42.0355 18.4372L40.0046 16.4063C40.1931 16.0112 40.307 15.5758 40.307 15.1102C40.307 13.4432 38.9504 12.0866 37.2834 12.0866C35.6164 12.0866 34.2598 13.4432 34.2598 15.1102C34.2598 15.5758 34.3737 16.0112 34.5631 16.4053L29.5087 21.4598C29.1136 21.2713 28.6782 21.1574 28.2125 21.1574C26.5455 21.1574 25.1889 22.514 25.1889 24.181C25.1889 25.8481 26.5455 27.2047 28.2125 27.2047C29.8796 27.2047 31.2361 25.8481 31.2361 24.181C31.2361 23.7154 31.1223 23.28 30.9328 22.8859L35.9873 17.8315C36.3823 18.0199 36.8177 18.1338 37.2834 18.1338C37.749 18.1338 38.1844 18.0199 38.5785 17.8304L40.6094 19.8613C40.4209 20.2564 40.307 20.6918 40.307 21.1574C40.307 22.8245 41.6636 24.181 43.3306 24.181C44.9976 24.181 46.3542 22.8245 46.3542 21.1574C46.3542 20.6918 46.2403 20.2564 46.0509 19.8623L52.216 13.6982C53.1382 14.3896 54.2328 14.8582 55.4251 15.0306V33.4192C53.0495 32.0394 50.301 31.2361 47.3621 31.2361C42.5445 31.2361 38.2247 33.3708 35.2676 36.7321V32.244H29.2204V44.3385H31.5304C31.4055 44.9966 31.3299 45.6709 31.2875 46.3542H3.01574V10.0708ZM43.3306 20.1496C43.8859 20.1496 44.3385 20.6011 44.3385 21.1574C44.3385 21.7138 43.8859 22.1653 43.3306 22.1653C42.7753 22.1653 42.3227 21.7138 42.3227 21.1574C42.3227 20.6011 42.7753 20.1496 43.3306 20.1496ZM36.2755 15.1102C36.2755 14.5539 36.728 14.1023 37.2834 14.1023C37.8387 14.1023 38.2913 14.5539 38.2913 15.1102C38.2913 15.6665 37.8387 16.1181 37.2834 16.1181C36.728 16.1181 36.2755 15.6665 36.2755 15.1102ZM29.2204 24.181C29.2204 24.7374 28.7679 25.1889 28.2125 25.1889C27.6572 25.1889 27.2047 24.7374 27.2047 24.181C27.2047 23.6247 27.6572 23.1732 28.2125 23.1732C28.7679 23.1732 29.2204 23.6247 29.2204 24.181ZM47.3621 55.4251C42.9164 55.4251 39.2991 51.8078 39.2991 47.3621C39.2991 42.9164 42.9164 39.2991 47.3621 39.2991C51.8078 39.2991 55.4251 42.9164 55.4251 47.3621C55.4251 51.8078 51.8078 55.4251 47.3621 55.4251ZM33.2519 39.5723C32.7691 40.4431 32.37 41.3632 32.0535 42.3227H31.2361V34.2598H33.2519V39.5723ZM46.3542 33.3033V37.3348C41.2685 37.8427 37.2834 42.1454 37.2834 47.3621C37.2834 48.8366 37.6099 50.2345 38.1814 51.4984L34.6851 53.5172C33.776 51.6546 33.2519 49.5703 33.2519 47.3621C33.2519 39.922 39.0441 33.8234 46.3542 33.3033ZM47.3621 61.4723C42.5102 61.4723 38.2227 59.0101 35.6829 55.2688L39.1933 53.242C41.0256 55.7798 43.9998 57.4408 47.3621 57.4408C50.7244 57.4408 53.6986 55.7798 55.5309 53.242L59.0413 55.2688C56.5015 59.0101 52.214 61.4723 47.3621 61.4723ZM60.0391 53.5172L56.5428 51.4984C57.1143 50.2345 57.4408 48.8366 57.4408 47.3621C57.4408 42.1454 53.4557 37.8417 48.37 37.3348V33.3033C55.6801 33.8234 61.4723 39.922 61.4723 47.3621C61.4723 49.5703 60.9482 51.6546 60.0391 53.5172Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M47.3621 41.3154C44.0271 41.3154 41.3149 44.0276 41.3149 47.3627C41.3149 50.6977 44.0271 53.4099 47.3621 53.4099C50.6972 53.4099 53.4093 50.6977 53.4093 47.3627C53.4093 44.0276 50.6972 41.3154 47.3621 41.3154ZM47.3621 51.3941C45.1387 51.3941 43.3306 49.586 43.3306 47.3627C43.3306 45.1393 45.1387 43.3312 47.3621 43.3312C49.5855 43.3312 51.3936 45.1393 51.3936 47.3627C51.3936 49.586 49.5855 51.3941 47.3621 51.3941Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M5.03119 12.0874H7.04693V14.1031H5.03119V12.0874Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M9.06445 12.0874H23.1747V14.1031H9.06445V12.0874Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M5.03119 16.1182H7.04693V18.1339H5.03119V16.1182Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M9.06445 16.1182H23.1747V18.1339H9.06445V16.1182Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M5.03119 20.1494H7.04693V22.1652H5.03119V20.1494Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M9.06445 20.1494H23.1747V22.1652H9.06445V20.1494Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M5.03119 24.1812H7.04693V26.1969H5.03119V24.1812Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M9.06445 24.1812H23.1747V26.1969H9.06445V24.1812Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M5.03119 44.3385H11.0784V34.2598H5.03119V44.3385ZM7.04693 36.2755H9.06268V42.3227H7.04693V36.2755Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M13.0945 44.3389H19.1418V36.2759H13.0945V44.3389ZM15.1103 38.2916H17.126V42.3231H15.1103V38.2916Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M21.1569 44.3384H27.2042V28.2124H21.1569V44.3384ZM23.1727 30.2281H25.1884V42.3226H23.1727V30.2281Z"
                      fill="#E94E32"
                    />
                  </svg>

                  <p className="tbk-text-main">
                    A report of your employee engagement
                  </p>
                </div>
              </div>
            </div>
            <div className="we-provide-card tb-mg-b-2 tb-mg-lg-b-0 lg:tbk-mr-2">
              <div className="tbk-h-full">
                <div className="u-d-lg-block tb-shadow-box tbk-flex tbk-h-full tbk-rounded-lg tbk-bg-basic-white tbk-p-2">
                  <svg
                    width="64"
                    height="64"
                    viewBox="0 0 64 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="tbk-m-2 tbk-shrink-0 md:tbk-mb-2"
                  >
                    <path
                      d="M39.0397 21.259H28.9132C28.3982 21.259 27.9807 20.8416 27.9807 20.3265C27.9807 19.8114 28.3982 19.394 28.9132 19.394H39.0397C39.5547 19.394 39.9722 19.8114 39.9722 20.3265C39.9722 20.8416 39.5548 21.259 39.0397 21.259Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M49.1668 16.4719H28.9136C28.3986 16.4719 27.9811 16.0545 27.9811 15.5394C27.9811 15.0243 28.3986 14.6069 28.9136 14.6069H49.1668C49.6818 14.6069 50.0993 15.0243 50.0993 15.5394C50.0993 16.0545 49.6818 16.4719 49.1668 16.4719Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M39.0397 36.8865H28.9132C28.3982 36.8865 27.9807 36.4691 27.9807 35.954C27.9807 35.4389 28.3982 35.0215 28.9132 35.0215H39.0397C39.5547 35.0215 39.9722 35.4389 39.9722 35.954C39.9722 36.4691 39.5548 36.8865 39.0397 36.8865Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M49.1664 32.1003H28.9132C28.3982 32.1003 27.9807 31.683 27.9807 31.1678C27.9807 30.6527 28.3982 30.2354 28.9132 30.2354H49.1664C49.6814 30.2354 50.0989 30.6527 50.0989 31.1678C50.0989 31.683 49.6814 32.1003 49.1664 32.1003Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M39.0397 52.5139H28.9132C28.3982 52.5139 27.9807 52.0965 27.9807 51.5814C27.9807 51.0663 28.3982 50.6489 28.9132 50.6489H39.0397C39.5547 50.6489 39.9722 51.0663 39.9722 51.5814C39.9722 52.0965 39.5548 52.5139 39.0397 52.5139Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M49.1664 47.7263H28.9132C28.3982 47.7263 27.9807 47.3089 27.9807 46.7938C27.9807 46.2787 28.3982 45.8613 28.9132 45.8613H49.1664C49.6814 45.8613 50.0989 46.2787 50.0989 46.7938C50.0989 47.3089 49.6814 47.7263 49.1664 47.7263Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M39.9382 8.78422H23.8118C22.279 8.78422 21.032 7.53729 21.032 6.00452V2.77983C21.0321 1.24706 22.279 0 23.8118 0H39.9381C41.4709 0 42.718 1.24706 42.718 2.77983V6.00452C42.718 7.53729 41.471 8.78422 39.9382 8.78422ZM23.8118 1.86499C23.3074 1.86499 22.897 2.27541 22.897 2.77983V6.00452C22.897 6.50894 23.3074 6.91923 23.8118 6.91923H39.9381C40.4425 6.91923 40.853 6.50881 40.853 6.00452V2.77983C40.853 2.27529 40.4425 1.86499 39.9381 1.86499H23.8118Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M20.3033 22.5073H16.1589C14.7784 22.5073 13.6553 21.3842 13.6553 20.0038V15.8595C13.6553 14.4791 14.7784 13.356 16.1589 13.356H20.3033C21.6837 13.356 22.8068 14.4791 22.8068 15.8595V20.0039C22.8068 21.3842 21.6837 22.5073 20.3033 22.5073ZM16.1589 15.2209C15.8068 15.2209 15.5203 15.5074 15.5203 15.8595V20.0039C15.5203 20.356 15.8068 20.6425 16.1589 20.6425H20.3033C20.6554 20.6425 20.9418 20.356 20.9418 20.0039V15.8595C20.9418 15.5074 20.6554 15.2209 20.3033 15.2209H16.1589Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M20.3041 38.1339H16.1597C14.7792 38.1339 13.6561 37.0108 13.6561 35.6304V31.486C13.6561 30.1055 14.7792 28.9824 16.1597 28.9824H20.3041C21.6845 28.9824 22.8076 30.1055 22.8076 31.486V35.6304C22.8076 37.0108 21.6845 38.1339 20.3041 38.1339ZM16.1597 30.8474C15.8076 30.8474 15.5211 31.1339 15.5211 31.486V35.6304C15.5211 35.9825 15.8076 36.2689 16.1597 36.2689H20.3041C20.6562 36.2689 20.9426 35.9825 20.9426 35.6304V31.486C20.9426 31.1339 20.6562 30.8474 20.3041 30.8474H16.1597Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M20.3041 53.7615H16.1597C14.7792 53.7615 13.6561 52.6384 13.6561 51.2578V47.1136C13.6561 45.733 14.7792 44.6099 16.1597 44.6099H20.3041C21.6845 44.6099 22.8076 45.733 22.8076 47.1136V51.2578C22.8076 52.6384 21.6845 53.7615 20.3041 53.7615ZM16.1597 46.475C15.8076 46.475 15.5211 46.7616 15.5211 47.1137V51.2579C15.5211 51.61 15.8076 51.8966 16.1597 51.8966H20.3041C20.6562 51.8966 20.9426 51.61 20.9426 51.2579V47.1137C20.9426 46.7616 20.6562 46.475 20.3041 46.475H16.1597Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M51.7145 63.6576H12.0397C9.81215 63.6576 8 61.8455 8 59.6179V7.49855C8 5.27113 9.81227 3.45898 12.0397 3.45898H17.6278C18.1428 3.45898 18.5603 3.87637 18.5603 4.39148C18.5603 4.90659 18.1428 5.32397 17.6278 5.32397H12.0397C10.8405 5.32397 9.86499 6.29949 9.86499 7.49855V59.6178C9.86499 60.817 10.8406 61.7925 12.0397 61.7925H51.7145C52.9137 61.7925 53.8892 60.8168 53.8892 59.6178V7.49855C53.8892 6.29936 52.9135 5.32397 51.7145 5.32397H46.1263C45.6114 5.32397 45.1938 4.90659 45.1938 4.39148C45.1938 3.87637 45.6114 3.45898 46.1263 3.45898H51.7145C53.942 3.45898 55.7542 5.27113 55.7542 7.49855V59.6178C55.7542 61.8455 53.9419 63.6576 51.7145 63.6576Z"
                      fill="#E94E32"
                    />
                  </svg>

                  <p className="tbk-text-main">
                    A list of employees that have taken part
                  </p>
                </div>
              </div>
            </div>
            <div className="we-provide-card tb-mg-b-2 tb-mg-lg-b-0 lg:tbk-mr-2">
              <div className="tbk-h-full">
                <div className="u-d-lg-block tb-shadow-box tbk-flex tbk-h-full tbk-rounded-lg tbk-bg-basic-white tbk-p-2">
                  <svg
                    width="64"
                    height="64"
                    viewBox="0 0 64 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="tbk-m-2 tbk-shrink-0 md:tbk-mb-2"
                  >
                    <path
                      d="M40.2997 13.7931C40.1834 13.4332 39.9559 13.1194 39.6499 12.8971C39.3439 12.6748 38.9751 12.5554 38.5969 12.5561H35.1071L34.0287 9.23703C33.9118 8.87746 33.6841 8.56412 33.3783 8.3419C33.0724 8.11968 32.704 8 32.3259 8C31.9478 8 31.5794 8.11968 31.2736 8.3419C30.9677 8.56412 30.74 8.87746 30.6231 9.23703L29.5447 12.5561H26.0549C25.6768 12.5561 25.3085 12.6758 25.0026 12.898C24.6967 13.1203 24.469 13.4337 24.3522 13.7932C24.2353 14.1528 24.2353 14.5402 24.3521 14.8998C24.4689 15.2594 24.6966 15.5727 25.0025 15.795L27.8258 17.8461L26.7473 21.1652C26.63 21.5249 26.6297 21.9125 26.7464 22.2723C26.8631 22.6322 27.0908 22.9458 27.3969 23.1682C27.703 23.3905 28.0717 23.5102 28.45 23.5099C28.8283 23.5097 29.1968 23.3896 29.5026 23.1668L32.3259 21.1157L35.1492 23.167C35.4551 23.3892 35.8235 23.5089 36.2016 23.5089C36.5797 23.5089 36.9481 23.3892 37.254 23.1669C37.5599 22.9447 37.7876 22.6313 37.9044 22.2717C38.0213 21.9122 38.0213 21.5248 37.9045 21.1652L36.8261 17.8461L39.6494 15.7949C39.9558 15.5731 40.1839 15.2597 40.3008 14.9C40.4176 14.5402 40.4173 14.1526 40.2997 13.7931ZM35.0488 16.6458C34.8766 16.7709 34.7484 16.9473 34.6826 17.1498C34.6169 17.3522 34.6169 17.5703 34.6827 17.7727L35.7731 21.1287L32.918 19.0546C32.7459 18.9296 32.5386 18.8623 32.3259 18.8623C32.1132 18.8623 31.9059 18.9296 31.7338 19.0546L28.879 21.1287L29.9694 17.7727C30.0352 17.5703 30.0352 17.3522 29.9694 17.1498C29.9036 16.9473 29.7755 16.7709 29.6033 16.6458L26.7487 14.5718H30.2772C30.49 14.5718 30.6974 14.5045 30.8696 14.3794C31.0418 14.2542 31.17 14.0778 31.2358 13.8754L32.3259 10.5195L33.4163 13.8755C33.4821 14.0779 33.6102 14.2544 33.7825 14.3795C33.9547 14.5046 34.1621 14.572 34.3749 14.5719H37.9033L35.0488 16.6458Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M19.8215 28.1554C20.0784 28.1551 20.3316 28.0941 20.5604 27.9773C20.7892 27.8605 20.9872 27.6913 21.1381 27.4835C21.289 27.2756 21.3887 27.035 21.4289 26.7812C21.4692 26.5275 21.4488 26.2679 21.3696 26.0235L20.5623 23.5391L22.6758 22.0036C22.9539 21.8016 23.1609 21.5166 23.2671 21.1897C23.3733 20.8628 23.3733 20.5106 23.2671 20.1837C23.1609 19.8567 22.9539 19.5718 22.6757 19.3698C22.3976 19.1677 22.0627 19.0589 21.719 19.0589H19.1067L18.2994 16.5745C18.1931 16.2475 17.9861 15.9626 17.708 15.7606C17.4299 15.5585 17.095 15.4497 16.7512 15.4497C16.4075 15.4497 16.0725 15.5585 15.7944 15.7606C15.5163 15.9626 15.3093 16.2475 15.2031 16.5745L14.3958 19.059H11.7834C11.4395 19.0589 11.1045 19.1676 10.8263 19.3696C10.5481 19.5716 10.341 19.8565 10.2347 20.1835C10.1284 20.5105 10.1283 20.8627 10.2345 21.1897C10.3407 21.5167 10.5477 21.8017 10.8259 22.0038L12.9394 23.5392L12.1323 26.0237C12.0261 26.3506 12.0261 26.7027 12.1323 27.0297C12.2385 27.3566 12.4455 27.6415 12.7236 27.8436C13.0017 28.0456 13.3366 28.1545 13.6803 28.1545C14.0241 28.1545 14.359 28.0458 14.6371 27.8437L16.7506 26.3081L18.8642 27.8437C19.1423 28.0463 19.4775 28.1554 19.8215 28.1554ZM16.1586 24.2469L14.4188 25.5117L15.0835 23.4662C15.1493 23.2637 15.1493 23.0456 15.0835 22.8431C15.0177 22.6407 14.8895 22.4642 14.7173 22.3391L12.9774 21.0751H15.1281C15.3409 21.0751 15.5483 21.0078 15.7205 20.8827C15.8926 20.7576 16.0208 20.5812 16.0866 20.3788L16.7512 18.3333L17.4158 20.3788C17.4816 20.5812 17.6098 20.7576 17.782 20.8827C17.9542 21.0078 18.1615 21.0751 18.3743 21.0751H20.5249L18.785 22.3393C18.6128 22.4644 18.4847 22.6408 18.4189 22.8432C18.3531 23.0457 18.3531 23.2637 18.4189 23.4662L19.0835 25.5117L17.3435 24.2474C17.1714 24.1222 16.9641 24.0548 16.7512 24.0547C16.5384 24.0546 16.331 24.1219 16.1588 24.2469H16.1586Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M13.5634 32.161H10.951L10.1437 29.6766C10.0375 29.3497 9.83052 29.0647 9.55242 28.8627C9.27431 28.6606 8.93938 28.5518 8.59561 28.5518C8.25185 28.5518 7.91691 28.6606 7.63881 28.8627C7.36071 29.0647 7.15372 29.3497 7.04752 29.6766L6.24009 32.1611H3.62781C3.28406 32.1612 2.94912 32.27 2.67102 32.472C2.39291 32.6741 2.18591 32.959 2.07968 33.2859C1.97345 33.6129 1.97344 33.965 2.07966 34.292C2.18588 34.6189 2.39287 34.9038 2.67097 35.1059L4.78447 36.6414L3.97717 39.1259C3.87091 39.4529 3.87089 39.805 3.97711 40.132C4.08332 40.459 4.29032 40.7439 4.56843 40.946C4.84654 41.148 5.18149 41.2569 5.52526 41.2569C5.86903 41.2569 6.20399 41.1481 6.48211 40.946L8.59561 39.4104L10.7091 40.946C10.9873 41.1483 11.3223 41.2573 11.6662 41.2573C12.0101 41.2574 12.3452 41.1486 12.6234 40.9464C12.9016 40.7443 13.1086 40.4592 13.2148 40.1321C13.321 39.805 13.3209 39.4527 13.2144 39.1257L12.4073 36.6413L14.5208 35.1058C14.7989 34.9037 15.0059 34.6187 15.1121 34.2917C15.2183 33.9647 15.2183 33.6125 15.112 33.2855C15.0056 32.9585 14.7985 32.6736 14.5203 32.4716C14.2421 32.2696 13.9071 32.1609 13.5633 32.161H13.5634ZM10.6295 35.4408C10.4572 35.5659 10.329 35.7423 10.2632 35.9448C10.1974 36.1472 10.1975 36.3653 10.2633 36.5678L10.928 38.6138L9.18799 37.349C9.01585 37.2241 8.80859 37.1568 8.59586 37.1568C8.38314 37.1568 8.17588 37.2241 8.00374 37.349L6.26327 38.6138L6.92784 36.5678C6.99363 36.3654 6.99365 36.1473 6.92788 35.9449C6.86211 35.7424 6.73394 35.566 6.56173 35.4409L4.82189 34.1768H6.97244C7.18525 34.1768 7.39261 34.1094 7.56479 33.9843C7.73697 33.8592 7.86513 33.6828 7.93092 33.4805L8.59561 31.435L9.26018 33.4805C9.32597 33.6828 9.45413 33.8592 9.62631 33.9843C9.79849 34.1094 10.0058 34.1768 10.2187 34.1768H12.3693L10.6295 35.4408Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M60.9337 32.161H58.3213L57.514 29.6766C57.4078 29.3497 57.2008 29.0647 56.9227 28.8627C56.6446 28.6606 56.3097 28.5518 55.9659 28.5518C55.6222 28.5518 55.2872 28.6606 55.0091 28.8627C54.731 29.0647 54.524 29.3497 54.4178 29.6766L53.6104 32.1611H50.9981C50.6543 32.161 50.3193 32.2698 50.0411 32.4718C49.7629 32.6738 49.5558 32.9587 49.4495 33.2856C49.3432 33.6126 49.3431 33.9648 49.4493 34.2918C49.5555 34.6188 49.7625 34.9038 50.0407 35.1059L52.1542 36.6414L51.3469 39.1259C51.2406 39.4529 51.2406 39.805 51.3468 40.132C51.453 40.459 51.66 40.7439 51.9381 40.946C52.2162 41.148 52.5512 41.2569 52.895 41.2569C53.2387 41.2569 53.5737 41.1481 53.8518 40.946L55.9653 39.4104L58.0788 40.946C58.3569 41.1485 58.6921 41.2577 59.0361 41.2579C59.3801 41.2581 59.7154 41.1493 59.9937 40.9471C60.2721 40.7449 60.4792 40.4597 60.5854 40.1325C60.6916 39.8052 60.6914 39.4528 60.5848 39.1257L59.7776 36.6413L61.8911 35.1058C62.1692 34.9037 62.3762 34.6187 62.4824 34.2917C62.5886 33.9647 62.5886 33.6125 62.4823 33.2855C62.376 32.9585 62.1689 32.6736 61.8906 32.4716C61.6124 32.2696 61.2774 32.1609 60.9336 32.161H60.9337ZM57.9998 35.4408C57.8276 35.5659 57.6993 35.7423 57.6336 35.9448C57.5678 36.1472 57.5678 36.3654 57.6336 36.5678L58.2983 38.6138L56.5583 37.349C56.3862 37.2241 56.1789 37.1568 55.9662 37.1568C55.7535 37.1568 55.5462 37.2241 55.3741 37.349L53.6336 38.6138L54.2982 36.5678C54.364 36.3654 54.364 36.1473 54.2982 35.9449C54.2324 35.7424 54.1043 35.566 53.932 35.4409L52.1922 34.1768H54.3428C54.5556 34.1768 54.7629 34.1094 54.9351 33.9843C55.1073 33.8592 55.2355 33.6828 55.3012 33.4805L55.9659 31.435L56.6305 33.4805C56.6963 33.6828 56.8245 33.8592 56.9966 33.9843C57.1688 34.1094 57.3762 34.1768 57.589 34.1768H59.7397L57.9998 35.4408Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M50.9716 28.1555C51.2286 28.1553 51.4818 28.0944 51.7107 27.9776C51.9396 27.8609 52.1377 27.6917 52.2887 27.4838C52.4397 27.2759 52.5394 27.0353 52.5796 26.7815C52.6199 26.5277 52.5995 26.268 52.5202 26.0236L51.7131 23.5392L53.8266 22.0037C54.1047 21.8016 54.3117 21.5166 54.4179 21.1896C54.5241 20.8626 54.5241 20.5104 54.4178 20.1835C54.3114 19.8565 54.1043 19.5716 53.8261 19.3696C53.5479 19.1676 53.2129 19.0588 52.8691 19.059H50.2568L49.4495 16.5746C49.3433 16.2476 49.1363 15.9627 48.8582 15.7606C48.5801 15.5585 48.2452 15.4497 47.9014 15.4497C47.5577 15.4497 47.2227 15.5585 46.9446 15.7606C46.6665 15.9627 46.4595 16.2476 46.3533 16.5746L45.5459 19.0591H42.9336C42.5898 19.059 42.2548 19.1677 41.9766 19.3697C41.6984 19.5717 41.4913 19.8566 41.385 20.1836C41.2786 20.5105 41.2786 20.8628 41.3848 21.1898C41.491 21.5168 41.698 21.8017 41.9761 22.0038L44.0896 23.5393L43.2823 26.0239C43.1761 26.3508 43.1761 26.703 43.2823 27.0299C43.3885 27.3569 43.5955 27.6418 43.8736 27.8439C44.1517 28.046 44.4867 28.1548 44.8304 28.1548C45.1742 28.1548 45.5092 28.046 45.7873 27.844L47.9008 26.3083L50.0143 27.844C50.2924 28.0465 50.6276 28.1556 50.9716 28.1555ZM47.3089 24.247L45.5691 25.5117L46.2336 23.4658C46.2994 23.2633 46.2995 23.0453 46.2337 22.8428C46.1679 22.6404 46.0397 22.4639 45.8675 22.3388L44.1277 21.0747H46.2782C46.4911 21.0747 46.6984 21.0073 46.8706 20.8823C47.0428 20.7572 47.1709 20.5808 47.2367 20.3784L47.9014 18.3329L48.566 20.3784C48.6318 20.5808 48.7599 20.7572 48.9321 20.8823C49.1043 21.0073 49.3117 21.0747 49.5245 21.0747H51.6751L49.9353 22.3387C49.763 22.4638 49.6348 22.6403 49.569 22.8427C49.5032 23.0452 49.5033 23.2633 49.5691 23.4658L50.2338 25.5117L48.4938 24.247C48.3216 24.1219 48.1142 24.0545 47.9014 24.0545C47.6886 24.0545 47.4812 24.1219 47.309 24.247H47.3089Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M44.4223 37.3169H37.3672V32.2776C37.3659 31.2087 36.9408 30.184 36.185 29.4283C35.4292 28.6725 34.4045 28.2473 33.3357 28.2461H31.3199C31.0773 28.2461 30.8429 28.3336 30.6596 28.4926C30.4764 28.6515 30.3566 28.8712 30.3223 29.1114L29.9517 31.7046C29.7829 32.8821 29.3398 34.0035 28.6582 34.9783C27.9765 35.9531 27.0753 36.7542 26.0273 37.3169H18.2176C17.9503 37.3169 17.6939 37.4231 17.5049 37.6121C17.3159 37.8012 17.2097 38.0575 17.2097 38.3248V52.435C17.2097 52.7023 17.3159 52.9587 17.5049 53.1477C17.6939 53.3367 17.9503 53.4429 18.2176 53.4429H25.9754L26.6352 53.8828C28.1758 54.912 29.9873 55.4604 31.84 55.4586H43.4144C43.9982 55.4589 44.5696 55.2901 45.0595 54.9726C45.5494 54.6551 45.9369 54.2025 46.1751 53.6695C46.4133 53.1364 46.492 52.5458 46.4017 51.9691C46.3114 51.3923 46.0559 50.854 45.6662 50.4193C46.1631 49.8655 46.438 49.1476 46.438 48.4035C46.438 47.6595 46.1631 46.9416 45.6662 46.3878C46.0879 45.9178 46.3516 45.3274 46.4201 44.6997C46.4887 44.072 46.3587 43.4386 46.0485 42.8887C46.5995 42.5367 47.0216 42.0156 47.2515 41.4034C47.4813 40.7913 47.5065 40.1211 47.3233 39.4934C47.1401 38.8657 46.7584 38.3143 46.2353 37.9219C45.7123 37.5295 45.0761 37.3172 44.4223 37.3169ZM19.2255 39.3327H25.2727V51.4271H19.2255V39.3327ZM44.4223 41.3484H43.4144C43.1471 41.3484 42.8907 41.4546 42.7017 41.6436C42.5127 41.8326 42.4065 42.089 42.4065 42.3563C42.4065 42.6236 42.5127 42.88 42.7017 43.069C42.8907 43.258 43.1471 43.3642 43.4144 43.3642C43.6817 43.3642 43.938 43.4704 44.1271 43.6594C44.3161 43.8484 44.4223 44.1047 44.4223 44.372C44.4223 44.6393 44.3161 44.8957 44.1271 45.0847C43.938 45.2737 43.6817 45.3799 43.4144 45.3799C43.1471 45.3799 42.8907 45.4861 42.7017 45.6751C42.5127 45.8641 42.4065 46.1205 42.4065 46.3878C42.4065 46.6551 42.5127 46.9114 42.7017 47.1005C42.8907 47.2895 43.1471 47.3957 43.4144 47.3957C43.6817 47.3957 43.938 47.5018 44.1271 47.6909C44.3161 47.8799 44.4223 48.1362 44.4223 48.4035C44.4223 48.6708 44.3161 48.9272 44.1271 49.1162C43.938 49.3052 43.6817 49.4114 43.4144 49.4114C43.1471 49.4114 42.8907 49.5176 42.7017 49.7066C42.5127 49.8956 42.4065 50.152 42.4065 50.4193C42.4065 50.6866 42.5127 50.9429 42.7017 51.1319C42.8907 51.321 43.1471 51.4271 43.4144 51.4271C43.6817 51.4271 43.938 51.5333 44.1271 51.7223C44.3161 51.9114 44.4223 52.1677 44.4223 52.435C44.4223 52.7023 44.3161 52.9587 44.1271 53.1477C43.938 53.3367 43.6817 53.4429 43.4144 53.4429H31.84C30.3853 53.4443 28.963 53.0136 27.7533 52.2056L27.2884 51.8957V38.9237C28.5367 38.1929 29.604 37.1897 30.4106 35.989C31.2173 34.7883 31.7425 33.421 31.9472 31.9891L32.194 30.2612H33.3357C33.8701 30.2618 34.3824 30.4744 34.7603 30.8523C35.1382 31.2302 35.3508 31.7425 35.3514 32.277V38.3242C35.3514 38.5915 35.4576 38.8478 35.6466 39.0369C35.8356 39.2259 36.092 39.3321 36.3593 39.3321H44.4223C44.6896 39.3321 44.9459 39.4382 45.1349 39.6273C45.3239 39.8163 45.4301 40.0726 45.4301 40.3399C45.4301 40.6072 45.3239 40.8636 45.1349 41.0526C44.9459 41.2416 44.6896 41.3478 44.4223 41.3478V41.3484Z"
                      fill="#E94E32"
                    />
                  </svg>

                  <p className="tbk-text-main">
                    Which classes have most uptake
                  </p>
                </div>
              </div>
            </div>
            <div className="we-provide-card tb-mg-b-2 tb-mg-lg-b-0 lg:tbk-mr-2">
              <div className="tbk-h-full">
                <div className="u-d-lg-block tb-shadow-box tbk-flex tbk-h-full tbk-rounded-lg tbk-bg-basic-white tbk-p-2">
                  <svg
                    width="65"
                    height="64"
                    viewBox="0 0 65 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="tbk-m-2 tbk-shrink-0 md:tbk-mb-2"
                  >
                    <path
                      d="M3.77322 32.2234H3.8085C4.35199 32.2238 4.79785 31.7931 4.81637 31.2498C5.36163 15.6737 18.4306 3.48876 34.0067 4.03389C39.998 4.24365 45.7668 6.35577 50.477 10.0644H45.1131C44.5565 10.0644 44.1052 10.5156 44.1052 11.0722C44.1052 11.6288 44.5565 12.0801 45.1131 12.0801H53.1761H53.1902C53.2691 12.0737 53.3468 12.0582 53.422 12.0337C53.4735 12.0263 53.5243 12.0152 53.5742 12.0005C53.6024 11.9884 53.6236 11.9632 53.6508 11.9481C53.7412 11.9039 53.8243 11.8456 53.8967 11.7757L53.9068 11.7687C53.9324 11.7337 53.9557 11.697 53.9763 11.6588C54.0291 11.5946 54.0736 11.5238 54.1084 11.4482C54.1361 11.3678 54.1531 11.2841 54.1588 11.1992C54.1703 11.1577 54.1788 11.1152 54.184 11.0722V3.00926C54.184 2.45266 53.7327 2.00139 53.1761 2.00139C52.6195 2.00139 52.1682 2.45266 52.1682 3.00926V8.84685C39.2547 -1.73353 20.209 0.15774 9.62858 13.0713C5.42916 18.1969 3.03017 24.5602 2.80063 31.1823C2.78198 31.7383 3.21726 32.2043 3.77322 32.2234Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M11.9344 50.9918C11.5645 50.5743 10.9263 50.5358 10.5088 50.9057C10.0913 51.2755 10.0527 51.9138 10.4226 52.3313C11.1164 53.1099 11.8494 53.8527 12.6188 54.5567C13.0372 54.9239 13.6739 54.8823 14.0411 54.4641C14.3979 54.0575 14.3702 53.442 13.9784 53.069C13.262 52.412 12.5798 51.7187 11.9344 50.9918Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M23.9595 58.9729C23.038 58.6609 22.1335 58.3013 21.2493 57.8955C20.7505 57.6484 20.1458 57.8525 19.8988 58.3513C19.6517 58.85 19.8558 59.4548 20.3546 59.7018C20.3717 59.7103 20.3891 59.7183 20.4067 59.7258C21.3546 60.1622 22.325 60.5483 23.3134 60.8828C23.8408 61.0612 24.413 60.7782 24.5914 60.2509C24.7699 59.7235 24.487 59.1513 23.9595 58.9729Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M18.6675 56.5412V56.5402C17.8298 56.0439 17.0179 55.5057 16.2345 54.9276C15.7975 54.5828 15.1638 54.6576 14.819 55.0947C14.4741 55.5317 14.549 56.1654 14.986 56.5102C15.0024 56.5231 15.019 56.5355 15.0361 56.5474C15.8739 57.1676 16.7429 57.7445 17.6395 58.2759C18.1185 58.5597 18.7369 58.4016 19.0208 57.9226C19.3047 57.4435 19.1465 56.825 18.6675 56.5412Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M10.1073 48.718C9.53912 47.9281 9.01175 47.1096 8.52696 46.2659C8.24867 45.783 7.6316 45.6172 7.1487 45.8955C6.6658 46.1738 6.50001 46.7909 6.77831 47.2738C7.29761 48.1759 7.86278 49.0509 8.47153 49.8952C8.80577 50.3403 9.43758 50.4302 9.88268 50.0959C10.3151 49.7713 10.4142 49.1633 10.1073 48.718Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M7.29578 44.0805C7.29578 43.94 7.2663 43.801 7.20948 43.6727L7.20746 43.6656C6.81301 42.7772 6.46479 41.8688 6.16432 40.9444C6.01817 40.4073 5.46422 40.0903 4.92715 40.2366C4.39008 40.3827 4.07311 40.9367 4.21938 41.4737C4.22794 41.505 4.23789 41.5359 4.24936 41.5662C4.571 42.5591 4.94378 43.5347 5.36608 44.489C5.52772 44.8539 5.88929 45.089 6.28828 45.0887C6.84488 45.0885 7.2959 44.6371 7.29578 44.0805Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M4.63518 39.318C4.63531 39.318 4.63556 39.3179 4.63569 39.3179C5.17956 39.202 5.52677 38.6676 5.41175 38.1236C5.21093 37.1715 5.05887 36.2097 4.95619 35.242C4.89748 34.6882 4.40085 34.2868 3.84703 34.3455C3.2932 34.4043 2.89182 34.9009 2.95053 35.4547C3.06089 36.4912 3.22429 37.5212 3.44035 38.5408C3.55575 39.0854 4.09068 39.4333 4.63518 39.318Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M61.6429 38.2886C61.6425 38.2885 61.6421 38.2885 61.6417 38.2883C61.1015 38.1545 60.5551 38.4839 60.4212 39.0241C60.1876 39.969 59.9054 40.9011 59.5756 41.8169C59.3869 42.3407 59.6585 42.9183 60.1823 43.107C60.7062 43.2957 61.2837 43.0241 61.4724 42.5002C61.826 41.5195 62.1288 40.5209 62.3795 39.5089C62.513 38.9685 62.1832 38.4223 61.6429 38.2886Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M29.6436 60.2554C28.6775 60.1404 27.7182 59.9756 26.7691 59.7616C26.2261 59.6389 25.6864 59.9795 25.5637 60.5225C25.441 61.0655 25.7817 61.6052 26.3247 61.7279C27.3418 61.9572 28.3703 62.1339 29.4057 62.2571C29.4459 62.262 29.4862 62.2643 29.5267 62.2641C30.0833 62.263 30.5335 61.8107 30.5324 61.2541C30.5314 60.7444 30.1499 60.3157 29.6436 60.2554Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M59.7853 44.0375C59.2842 43.7956 58.682 44.0054 58.4397 44.5062C58.016 45.3823 57.5471 46.2358 57.0347 47.0631C56.7497 47.5414 56.9064 48.1599 57.3847 48.4448C57.8512 48.7228 58.4543 48.5811 58.7481 48.1244C59.2966 47.2376 59.7989 46.3228 60.2528 45.384C60.4956 44.8831 60.2862 44.2803 59.7853 44.0375Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M56.8085 49.2794C56.3728 48.9329 55.7387 49.0052 55.3923 49.441C55.3862 49.4486 55.3803 49.4562 55.3745 49.4639V49.4619C54.7799 50.2333 54.1458 50.9733 53.4747 51.6792C53.0909 52.0828 53.1069 52.7211 53.5105 53.1049C53.914 53.4886 54.5523 53.4726 54.9361 53.0691C55.6537 52.3128 56.3326 51.5206 56.97 50.6955C57.3164 50.2599 57.2441 49.6258 56.8085 49.2794Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M62.2648 32.2845C61.7173 32.2566 61.2506 32.6778 61.2228 33.2254C61.2223 33.2356 61.2219 33.2459 61.2217 33.2561C61.1875 34.2287 61.103 35.1989 60.9687 36.1628C60.8927 36.7135 61.277 37.2216 61.8274 37.2987C61.8741 37.3055 61.9212 37.3089 61.9685 37.3088C62.4708 37.308 62.896 36.9375 62.9653 36.44C63.1088 35.4075 63.1992 34.3684 63.2364 33.3267C63.2557 32.7707 62.8209 32.3042 62.2648 32.2845Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M51.3622 53.6839V53.6869C50.6204 54.3201 49.8467 54.9149 49.0441 55.4688C48.5851 55.786 48.4704 56.4153 48.7876 56.8743C49.1048 57.3332 49.7341 57.448 50.1931 57.1308C51.0514 56.5348 51.8789 55.8956 52.6724 55.2158C53.0955 54.854 53.1451 54.2178 52.7833 53.7947C52.4216 53.3717 51.7853 53.322 51.3622 53.6839Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M41.1938 59.2562C40.2624 59.5369 39.3171 59.7689 38.3617 59.9516C37.815 60.0568 37.4571 60.5851 37.5623 61.1317C37.6534 61.6055 38.0676 61.9483 38.5501 61.9492C38.614 61.9495 38.6778 61.9437 38.7406 61.9321C39.7649 61.7363 40.7782 61.4871 41.7763 61.1853C42.305 61.011 42.5923 60.4412 42.4181 59.9126C42.25 59.4026 41.7116 59.114 41.1938 59.2562Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M35.5232 60.3477C35.5047 60.3487 35.4863 60.3503 35.4679 60.3523L35.473 60.3563C34.6667 60.4249 33.8412 60.4571 33.0188 60.4571H32.5582C32.0085 60.4649 31.5593 60.8978 31.5312 61.4469C31.5211 62.0035 31.9641 62.4628 32.5205 62.4729C32.5207 62.4729 32.5208 62.4729 32.5209 62.4729H33.0188C33.8997 62.4729 34.7826 62.4336 35.6393 62.36C36.195 62.328 36.6195 61.8515 36.5874 61.2958C36.5553 60.7401 36.0788 60.3155 35.5232 60.3477Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M46.5629 56.9992H46.564C45.7107 57.4664 44.8341 57.8896 43.9374 58.2671C43.4217 58.4763 43.1731 59.064 43.3822 59.5798C43.5914 60.0956 44.1792 60.3442 44.695 60.135C44.7025 60.132 44.71 60.1289 44.7174 60.1256C45.6782 59.7213 46.6174 59.2679 47.5314 58.767C48.0196 58.4995 48.1985 57.887 47.931 57.3988C47.6638 56.9106 47.0511 56.7317 46.5629 56.9992Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M33.0174 11.0715C21.3281 11.0715 11.8521 20.5475 11.8521 32.2368C11.8521 43.9261 21.3281 53.4021 33.0174 53.4021C44.7066 53.4021 54.1827 43.9261 54.1827 32.2368C54.1694 20.5531 44.7011 11.0849 33.0174 11.0715ZM49.1433 33.2447H52.1155C51.5919 43.0106 43.7911 50.8114 34.0252 51.335V48.3628C34.0252 47.8062 33.574 47.3549 33.0174 47.3549C32.4608 47.3549 32.0095 47.8062 32.0095 48.3628V51.335C22.2436 50.8114 14.4428 43.0106 13.9192 33.2447H16.8914C17.448 33.2447 17.8993 32.7934 17.8993 32.2368C17.8993 31.6802 17.448 31.229 16.8914 31.229H13.9192C14.4428 21.4631 22.2436 13.6623 32.0095 13.1387V16.1109C32.0095 16.6675 32.4608 17.1188 33.0174 17.1188C33.574 17.1188 34.0252 16.6675 34.0252 16.1109V13.1387C43.7911 13.6623 51.5919 21.4631 52.1155 31.229H49.1433C48.5867 31.229 48.1354 31.6802 48.1354 32.2368C48.1354 32.7934 48.5867 33.2447 49.1433 33.2447Z"
                      fill="#E94E32"
                    />
                    <path
                      d="M34.0265 29.3984V20.1421C34.0265 19.5856 33.5752 19.1343 33.0186 19.1343C32.462 19.1343 32.0107 19.5856 32.0107 20.1421V29.3984C31.1572 29.7033 30.4853 30.3752 30.1804 31.2287H24.9556C24.399 31.2287 23.9478 31.68 23.9478 32.2366C23.9478 32.7932 24.399 33.2445 24.9556 33.2445H30.1804C30.7327 34.8163 32.4547 35.6427 34.0265 35.0904C35.5982 34.5381 36.4247 32.8161 35.8724 31.2444C35.569 30.3809 34.89 29.7019 34.0265 29.3984ZM33.0186 33.2445C32.462 33.2445 32.0107 32.7932 32.0107 32.2366C32.0107 31.68 32.462 31.2287 33.0186 31.2287C33.5752 31.2287 34.0265 31.68 34.0265 32.2366C34.0265 32.7932 33.5753 33.2445 33.0186 33.2445Z"
                      fill="#E94E32"
                    />
                  </svg>

                  <p className="tbk-text-main">
                    What exercise times are most popular
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row tb-mg-t-5">
            <div className="col-12">
              <a
                href="#get-in-touch"
                className="tb-button text-uppercase js-get-in-touch-button"
              >
                Find out more
              </a>
            </div>
          </div>
        </div>
      </section>

      <section
        className="section-eight-unique-disciplines tbk-relative tbk-bg-basic-white tbk-pt-4 md:tbk-pb-24 md:tbk-pt-24"
        style={{
          overflow: "hidden",
          backgroundRepeat: "no-repeat",
          // backgroundImage: url('<?php echo $public_path ?>/images/corporate-page-ellipse-3.svg')
        }}
      >
        <div className="tbk-bg-basic-white_">
          <div className="tbk-container tbk-mx-auto tbk-px-2 lg:tbk-px-9">
            <div className="tbk-grid tbk-items-center lg:tbk-grid-cols-2">
              <div className="tbk-pb-7 md:tbk-pt-7">
                <div className="lg:tbk-px-2">
                  <h2 className="tbk-text-h2-black md:tbk-text-epic-medium text-uppercase tbk-mb-2 tbk-text-center !tbk-leading-small tbk-tracking-tight tbk-text-primary md:tbk-mb-7 md:tbk-leading-none md:tbk-tracking-normal">
                    Our <span className="tbk-text-coral">Trainers</span>
                  </h2>
                  <p className="tbk-text-main">
                    Through our strict qualification criteria and diligent
                    background checks, we ensure that every trainer meets our
                    gold standard of providing the best service.
                  </p>
                  <p className="tbk-text-main">
                    This qualifying criterion includes, but not limited to:
                  </p>
                  <br />

                  <ul className="tbk-mb-4 tbk-list-disc">
                    <li className="tbk-text-main tbk-ml-3 tbk-shrink-0 tbk-grow">
                      Degrees within their exercise fields
                    </li>
                    <li className="tbk-text-main tbk-ml-3 tbk-shrink-0 tbk-grow">
                      Minimum number of year’s experience
                    </li>
                    <li className="tbk-text-main tbk-ml-3 tbk-shrink-0 tbk-grow">
                      Proven track record of customer satisfaction
                    </li>
                    <li className="tbk-text-main tbk-ml-3 tbk-shrink-0 tbk-grow">
                      Background Checks
                    </li>
                    <li className="tbk-text-main tbk-ml-3 tbk-shrink-0 tbk-grow">
                      Fully Insured
                    </li>
                  </ul>

                  <div className="tbk-flex tbk-justify-center lg:tbk-justify-start">
                    <button
                      className="tbk-text-h3-subtitle tbk-inline-flex tbk-items-center tbk-text-coral hover:tbk-text-coral-light"
                      // onClick={handleMoreQuestionsClick}
                      onClick={scrollToForm}
                    >
                      Contact Us to Learn More
                      <ArrowRightIcon />
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-md-5 col-12 tbk-mt-7_ tbk-mb-7_ tbk-relative tbk-h-94 md:tbk-h-full">
                <div className="tbk-w-94"></div>
                <div className="inspiration-img-wrapper flex-end tbk-absolute tbk-flex">
                  <img
                    className="inspiration-img img-responsive"
                    src={inspirationStationImg}
                    alt="Inspiration Station"
                    srcSet={`${inspirationStationImg} 1x, ${inspirationStationImg2x} 2x, ${inspirationStationImg3x} 3x`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="tbk-overflow-hidden tbk-bg-grey-light tbk-pt-5 tbk-pb-24 lg:tbk-mb-0 lg:tbk-pt-9 lg:tbk-pb-24">
        <div className="lg:tbk-pb-24_ tbk-container tbk-mx-auto tbk-px-2 tbk-pb-1 lg:tbk-px-8">
          <div className="tbk-relative tbk-mb-6 tbk-text-center">
            <h3 className="tbk-text-title-bold lg:tbk-text-h2-black tbk-inline-block tbk-bg-grey-light tbk-px-2 tbk-text-center tbk-text-blue-grey">
              TruBe in the Press
            </h3>
            <hr className="tbk-mb-0 tbk--mt-1.5 tbk-border-blue-grey-light lg:tbk--mt-2" />
          </div>

          {/*<div className="tbk-relative tbk-mt-1 tbk-mb-6 lg:tbk-mb-8 lg:tbk-mt-1">*/}
          {/*  <div className="tbk-bg-basic-white tbk-py-0 tbk-pr-2 lg:tbk-pl-2">*/}
          {/*    <div className="tbk-text-h2-black lg:tbk-text-extra-bold tbk-inline-block tbk-text-grey-main">*/}
          {/*      Word on <span className="tbk-text-coral">the Street</span>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*  /!*<hr className="tbk-mx-auto tbk-mb-0 tbk--mt-[18px] tbk-border-blue-grey-light" />*!/*/}
          {/*</div>*/}

          <TruBeInPressSlider />
        </div>
      </div>

      <section
        className="testimonials-section tbk-pb-24_ md:tbk-pb-7_ corporate-page-testimonials_ background-fill-after background-fill-sm tbk-mb-0 tbk-bg-grey-light tbk-pt-7 md:tbk-pt-5"
        style={{ maxWidth: "100%" }}
      >
        <div className="_lg:tbk-px-2 tbk-mx-auto lg:tbk-container">
          {/*<hr />*/}

          <div className="row tbk-items-center">
            <div className="col-12">
              <div className="text-md-center_">
                <h3 className="tbk-text-title-bold lg:tbk-text-h2-black tbk-mt-6 tbk-mb-1 tbk-ml-1 tbk-text-blue-grey md:tbk-mb-2 md:tbk-ml-0 md:tbk-text-center">
                  What Our Clients Say
                </h3>
              </div>
            </div>
          </div>

          {/*<div className=" tbk-relative tbk-px-2">*/}
          {/*  <div className="tb-slider tbk-flex_ _tbk-grid tb-testimonials-slider tbk-grid-cols-1 tbk-flex-nowrap tbk-items-start tbk-justify-evenly tbk-gap-2 tbk-pt-3 tbk-pb-3 md:tbk-grid-cols-2 lg:tbk-grid-cols-3">*/}
          {/*    <div className="tb-slide tbk-w-100 tbk-shrink-0 tbk-grow tbk-rounded-lg lg:tbk-border tbk-border-grey-light tbk-bg-grey-light lg:tbk-bg-basic-white lg:tbk-shadow-trube lg:tbk-w-auto lg:tbk-basis-1/4">*/}
          {/*      <a id="testimonials-slide-1" className="anchor" target="_blank">*/}
          {/*        {" "}*/}
          {/*      </a>*/}
          {/*      <div className=" tbk-mx-1_ tbk-h-full tbk-p-2 md:tbk-p-4">*/}
          {/*        <a className="" target="_blank">*/}
          {/*          <cite>*/}
          {/*            <svg*/}
          {/*              id="f331c3a2-736f-4a93-89be-04f63aa04043"*/}
          {/*              data-name="Layer 1"*/}
          {/*              xmlns="http://www.w3.org/2000/svg"*/}
          {/*              width="188"*/}
          {/*              height="32"*/}
          {/*              viewBox="0 0 93.19 19.92"*/}
          {/*              className="tbk-mb-2"*/}
          {/*            >*/}
          {/*              <path*/}
          {/*                d="M7.89,9.64a8.67,8.67,0,0,1,1.52.1,1.76,1.76,0,0,1,1.17,1.42,2.73,2.73,0,0,1-.1.82,26.65,26.65,0,0,1-1.67,3.25c-.54-.87-1.8-3.33-2.24-4.29a2.66,2.66,0,0,1-.29-.9C6.28,9.74,6.88,9.64,7.89,9.64Zm-7.16,0a1.65,1.65,0,0,1,1.29,1c1.55,2.84,3.1,6,4.61,9.06a1,1,0,0,0,.73.19,1.07,1.07,0,0,0,.73-.19c.72-1.36,2.61-5,3.43-6.41,1,1.74,2.59,4.93,3.26,6.41a1,1,0,0,0,.72.19,1,1,0,0,0,.73-.19q2-4.39,4.23-8.69c.51-1,.72-1.27,1.77-1.47l.44-.07c.25-.26.19-.85-.09-1-.7.05-1.52.08-2.44.08s-1.54,0-2.59-.08c-.31.11-.31.76-.12,1l.53.1c.55.11.79.25.79.39a3.27,3.27,0,0,1-.29,1c-.5,1.27-1,2.61-1.76,4.19-.69-1.32-1.57-3.09-2.14-4.4a2.19,2.19,0,0,1-.25-.84c0-.14.43-.28,1.16-.42l.47-.07c.23-.12.26-.93-.09-1-1.86.05-3.73.08-5.59.08H3.88c-1.32,0-2.33,0-3.62-.08-.33.13-.33.73-.11,1Z"*/}
          {/*                transform="translate(0 0)"*/}
          {/*              />*/}
          {/*              <path*/}
          {/*                d="M27.1,9.46A1.47,1.47,0,0,1,28.77,11c0,.27-.06.55-.22.63a2.86,2.86,0,0,1-1.29.24H26.09c-1,0-1.45,0-1.45-.41a2.44,2.44,0,0,1,2.46-2Zm0,10.43a6.2,6.2,0,0,0,5.52-3.12.69.69,0,0,0-.82-.63,3.26,3.26,0,0,1-2.94,1.42c-2.93,0-4.45-2-4.45-4,0-.43.07-.49.79-.49h6.06c1,0,1.14-.38,1.14-.9,0-2.1-1.77-3.93-5-3.93-3.94,0-6.82,2.68-6.82,6.12C20.5,17.29,22.81,19.89,27.07,19.89ZM40.44,9.64a8.81,8.81,0,0,1,1.52.1,1.75,1.75,0,0,1,1.16,1.42A3,3,0,0,1,43,12a28.15,28.15,0,0,1-1.67,3.25c-.55-.87-1.8-3.33-2.24-4.29a2.66,2.66,0,0,1-.29-.9C38.83,9.74,39.43,9.64,40.44,9.64Zm-7.17,0a1.66,1.66,0,0,1,1.3,1c1.54,2.84,3.1,6,4.61,9.06a1,1,0,0,0,.73.19,1,1,0,0,0,.72-.19c.73-1.36,2.62-5,3.44-6.41,1,1.74,2.59,4.93,3.25,6.41a1,1,0,0,0,.73.19,1,1,0,0,0,.72-.19q2-4.39,4.24-8.69c.5-1,.72-1.27,1.76-1.47l.45-.07c.25-.26.18-.85-.1-1-.7.05-1.51.08-2.43.08s-1.73,0-2.59-.08c-.32.11-.32.76-.12,1l.53.1c.54.11.79.25.79.39A3.79,3.79,0,0,1,51,11c-.51,1.27-1,2.61-1.77,4.19-.7-1.32-1.58-3.09-2.15-4.4a2.19,2.19,0,0,1-.25-.84c0-.14.44-.28,1.17-.42l.47-.07c.22-.12.25-.93-.1-1-2,.05-3.6.08-5.58.08H36.43c-1.21,0-2.42,0-3.63-.08-.31.13-.31.73-.09,1Z"*/}
          {/*                transform="translate(0 0)"*/}
          {/*              />*/}
          {/*              <path*/}
          {/*                d="M60.3,9.46c1.79,0,2.68,2.29,2.71,4.94,0,2.46-.57,4.23-2.37,4.23s-2.87-2.1-2.87-5,1.14-4.2,2.53-4.2Zm0,10.43c3.88,0,7.26-1.89,7.26-5.88S64.21,8.2,60.49,8.2s-7.3,2.16-7.27,6.06S56.54,19.89,60.3,19.89Z"*/}
          {/*                transform="translate(0 0)"*/}
          {/*              />*/}
          {/*              <path*/}
          {/*                d="M72.94,10.51c.2,0,.48,0,1.2.55a1.86,1.86,0,0,0,1.23.49,1.79,1.79,0,0,0,2-1.77,1.65,1.65,0,0,0-1.74-1.61c-1.32,0-2.23.9-3.09,1.36-.25,0-.32-.13-.32-.33s.07-.62.12-1.17a.66.66,0,0,0-.56-.25,23,23,0,0,1-4.61,1.65.59.59,0,0,0,0,.82l.45.24c.59.33.59.66.59,1.75v4.12c0,1.91-.12,2.15-1.17,2.24l-.6,0a.67.67,0,0,0,0,1c1.24-.06,2.48-.09,3.72-.08,1.48,0,2.75,0,4.27.08a.68.68,0,0,0,0-1l-1-.08c-1.05-.08-1.17-.3-1.17-2.21v-4.2c0-1,.16-1.65.6-1.65"*/}
          {/*                transform="translate(0 0)"*/}
          {/*              />*/}
          {/*              <path*/}
          {/*                d="M85.33,18.56l-.41.08a.63.63,0,0,0,.12.95c.89-.05,2-.08,3.89-.08s3,0,4,.08c.32-.1.38-.76.13-.95l-.47-.08a4,4,0,0,1-1.86-.63,43,43,0,0,1-4.13-5.21,1,1,0,0,1-.24-.47c0-.08,0-.18.19-.35a19.07,19.07,0,0,1,2.12-1.59,5.62,5.62,0,0,1,2.12-1l1-.19a.68.68,0,0,0-.13-1,52.86,52.86,0,0,1-6,.39h-.75c-.32.11-.35.71-.07,1l.79.11c.29,0,.6.13.6.27s-.15.47-.75,1.09l-1.33,1.35a2.5,2.5,0,0,1-1.83.76c-.34,0-.45-.08-.45-.38V4.18c0-1.73,0-2.87.11-4A.76.76,0,0,0,81.45,0a37.84,37.84,0,0,1-4.83,1.52.57.57,0,0,0,0,.82l.53.28c.63.33.63.63.63,1.72v12c0,1.91-.12,2.13-1.27,2.24l-.59.06a.67.67,0,0,0,0,1c1.28-.06,2.57-.09,3.85-.08,1.45,0,2.78,0,3.79.08a.67.67,0,0,0,0-1l-.5-.06c-1.11-.11-1.24-.33-1.24-2.24V14.77c0-.52.16-.66.38-.66a.94.94,0,0,1,.8.4l2.24,3a3,3,0,0,1,.53.88c0,.1-.19.15-.5.21"*/}
          {/*                transform="translate(0 0)"*/}
          {/*              />*/}
          {/*            </svg>*/}
          {/*          </cite>*/}
          {/*        </a>*/}

          {/*        <h5 className="tbk-text-title-bold tbk-text-basic-trueblack">*/}
          {/*          An experience like no other*/}
          {/*        </h5>*/}
          {/*        <div className="tbk-text-h3-subtitle tbk-mb-2 tbk-text-grey">*/}
          {/*          Maddie North, 11th July 2019*/}
          {/*        </div>*/}
          {/*        <blockquote>*/}
          {/*          <p*/}
          {/*            className="tbk-text-main tbk-relative tbk-mb-5 tbk-text-primary"*/}
          {/*            style={{ minHeight: "260px" }}*/}
          {/*          >*/}
          {/*            TruBe have been excellent in WeWork, the masseuse that*/}
          {/*            come in are always very professional, they are always on*/}
          {/*            time so no one over runs for their meetings and the*/}
          {/*            members in the building always have such great feedback. I*/}
          {/*            will enjoy to continuously work with them*/}
          {/*          </p>*/}
          {/*          <div className="testimonial-footer tbk-mb-1 tbk-hidden">*/}
          {/*            <div className="tbk-text-main tbk-c-grey-medium tbk-mb-3">*/}
          {/*              Maddie North, 11th July 2019*/}
          {/*            </div>*/}
          {/*            <a*/}
          {/*              className="tb-session-link virtual tbk-c-basic-violet"*/}
          {/*              href="https://www.marieclaire.co.uk/life/health-fitness/motivation-monday-trube-the-on-demand-personal-training-app-71395"*/}
          {/*              target="_blank"*/}
          {/*            >*/}
          {/*              <cite>*/}
          {/*                <div*/}
          {/*                  className="tbk-text-main tbk-mb-3"*/}
          {/*                  style={{ minHeight: "78px" }}*/}
          {/*                >*/}
          {/*                  Motivation Monday: Here's What You Need To Know*/}
          {/*                  About TruBe, The On-Demand Personal Training App*/}
          {/*                </div>*/}
          {/*              </cite>*/}
          {/*            </a>*/}
          {/*          </div>*/}
          {/*        </blockquote>*/}
          {/*      </div>*/}
          {/*    </div>*/}

          {/*    <div className="tb-slide tbk-w-100 tbk-shrink-0 tbk-grow tbk-rounded-lg tbk-border tbk-border-grey-light tbk-bg-basic-white tbk-shadow-trube lg:tbk-w-auto lg:tbk-basis-1/4">*/}
          {/*      <a id="testimonials-slide-2" className="anchor" target="_blank">*/}
          {/*        {" "}*/}
          {/*      </a>*/}
          {/*      <div className=" tbk-mx-1_ tbk-h-full tbk-p-2 md:tbk-p-4">*/}
          {/*        <a className="" target="_blank">*/}
          {/*          <cite>*/}
          {/*            <svg*/}
          {/*              width="224"*/}
          {/*              height="32"*/}
          {/*              viewBox="0 0 224 32"*/}
          {/*              fill="none"*/}
          {/*              xmlns="http://www.w3.org/2000/svg"*/}
          {/*              className="tbk-mb-2"*/}
          {/*            >*/}
          {/*              <path*/}
          {/*                d="M41.8086 10.6667H62.7317V0H41.8086V10.6667Z"*/}
          {/*                fill="#0A9E01"*/}
          {/*              />*/}
          {/*              <path*/}
          {/*                d="M0 0V10.6667H10.4429V32H20.8858V10.6667H31.366V0H0Z"*/}
          {/*                fill="#0A9E01"*/}
          {/*              />*/}
          {/*              <path*/}
          {/*                d="M31.3662 32H62.7322V21.3333H41.8091V10.6667H31.3662V32Z"*/}
          {/*                fill="#0A9E01"*/}
          {/*              />*/}
          {/*              <path*/}
          {/*                d="M89.3992 8.05594H74.0332V12.4942H79.1801V26.4056H84.2523V12.4942H89.3992V8.05594Z"*/}
          {/*                fill="#0A9E01"*/}
          {/*              />*/}
          {/*              <path*/}
          {/*                d="M95.179 12.345C91.5613 12.345 88.876 14.7692 88.876 19.5431C88.876 23.7576 91.151 26.704 95.2909 26.704C97.4541 26.704 99.207 26.1445 100.885 25.1375L99.0951 22.1166C97.7151 22.8252 96.7454 23.0862 95.5147 23.0862C94.2466 23.0862 93.3515 22.4149 93.165 20.8858H101.258C101.296 20.662 101.296 20.3636 101.296 19.9534C101.333 14.8438 98.9832 12.345 95.179 12.345ZM93.2396 17.9394C93.3888 16.5594 93.9855 15.8508 95.0671 15.8508C96.4471 15.8508 96.9319 16.5594 97.1557 17.9394H93.2396Z"*/}
          {/*                fill="#0A9E01"*/}
          {/*              />*/}
          {/*              <path*/}
          {/*                d="M110.284 22.8625C109.016 22.8625 108.345 21.7436 108.345 19.5431C108.345 17.38 108.941 16.1492 110.172 16.1492C111.179 16.1492 111.627 16.7086 112.298 17.9394L115.543 15.4779C114.349 13.5385 112.857 12.345 110.247 12.345C105.846 12.345 103.683 15.2541 103.683 19.4685C103.683 24.0932 106.107 26.6667 110.135 26.6667C112.559 26.6667 114.051 25.7343 115.655 23.3846L112.671 21.035C111.776 22.3776 111.179 22.8625 110.284 22.8625Z"*/}
          {/*                fill="#0A9E01"*/}
          {/*              />*/}
          {/*              <path*/}
          {/*                d="M126.546 12.345C124.905 12.345 123.935 12.9044 123.077 13.5385V7.31003L118.341 9.21213V26.4429H123.077V18.5734C123.077 16.8578 123.674 16.373 124.681 16.373C125.651 16.373 126.248 16.8578 126.248 18.6107V26.4429H130.984V18.014C130.984 14.3963 129.53 12.345 126.546 12.345Z"*/}
          {/*                fill="#0A9E01"*/}
          {/*              />*/}
          {/*              <path*/}
          {/*                d="M142.359 22.2657C140.158 22.2657 139.263 20.028 139.263 17.2308C139.263 14.3217 140.195 12.1958 142.321 12.1958C144 12.1958 144.634 13.2774 145.268 14.993L149.892 13.1655C148.624 9.69698 146.834 7.75758 142.321 7.75758C137.398 7.75758 133.93 11.338 133.93 17.2308C133.93 22.676 136.839 26.704 142.284 26.704C146.648 26.704 148.699 24.3543 149.93 21.9674L145.641 19.6923C144.634 21.4079 143.962 22.2657 142.359 22.2657Z"*/}
          {/*                fill="black"*/}
          {/*              />*/}
          {/*              <path*/}
          {/*                d="M157.538 13.6504V12.6434H152.802V26.4056H157.538V18.9091C157.538 17.2308 158.247 16.6713 159.403 16.6713C160.336 16.6713 161.007 17.1562 161.604 17.8275L162.722 12.9417C162.163 12.6061 161.492 12.345 160.485 12.345C159.254 12.345 158.322 12.8671 157.538 13.6504Z"*/}
          {/*                fill="black"*/}
          {/*              />*/}
          {/*              <path*/}
          {/*                d="M172.829 20.5128C172.829 22.2284 172.233 22.7133 171.263 22.7133C170.293 22.7133 169.697 22.2284 169.697 20.4755V12.6433H164.96V21.0723C164.96 24.69 166.415 26.704 169.435 26.704C171.039 26.704 172.046 26.1445 172.867 25.5105V26.4429H177.603V12.6806H172.867V20.5128"*/}
          {/*                fill="black"*/}
          {/*              />*/}
          {/*              <path*/}
          {/*                d="M189.202 12.345C187.561 12.345 186.591 12.9044 185.734 13.5385V12.6061H180.997V26.3683H185.734V18.4988C185.734 16.7832 186.33 16.2984 187.337 16.2984C188.307 16.2984 188.904 16.7832 188.904 18.5361V26.3683H193.64V17.9394C193.64 14.3963 192.223 12.345 189.202 12.345Z"*/}
          {/*                fill="black"*/}
          {/*              />*/}
          {/*              <path*/}
          {/*                d="M203.039 22.8625C201.771 22.8625 201.1 21.7436 201.1 19.5431C201.1 17.38 201.696 16.1492 202.89 16.1492C203.897 16.1492 204.344 16.7086 205.016 17.9394L208.261 15.4779C207.067 13.5385 205.575 12.345 202.965 12.345C198.564 12.345 196.4 15.2541 196.4 19.4685C196.4 24.0932 198.825 26.6667 202.853 26.6667C205.277 26.6667 206.769 25.7343 208.372 23.3846L205.389 21.035C204.568 22.3776 203.934 22.8625 203.039 22.8625Z"*/}
          {/*                fill="black"*/}
          {/*              />*/}
          {/*              <path*/}
          {/*                d="M219.301 12.345C217.66 12.345 216.69 12.9044 215.832 13.5385V7.31003L211.096 9.21213V26.4429H215.832V18.5734C215.832 16.8578 216.429 16.373 217.436 16.373C218.406 16.373 219.002 16.8578 219.002 18.6107V26.4429H223.739V18.014C223.776 14.3963 222.322 12.345 219.301 12.345Z"*/}
          {/*                fill="black"*/}
          {/*              />*/}
          {/*            </svg>*/}
          {/*          </cite>*/}
          {/*        </a>*/}
          {/*        <h5 className="testimonial-heading tbk-text-title-bold tbk-text-basic-trueblack">*/}
          {/*          Fantastic experience*/}
          {/*        </h5>*/}
          {/*        <div className="tbk-text-h3-subtitle tbk-mb-2 tbk-text-grey">*/}
          {/*          Natasha Cambridge, 24th May 2018*/}
          {/*        </div>*/}
          {/*        <blockquote>*/}
          {/*          <p*/}
          {/*            className="tbk-text-main tbk-relative tbk-mb-5 tbk-text-primary"*/}
          {/*            style={{ minHeight: "260px" }}*/}
          {/*          >*/}
          {/*            TruBe trainers are fun, enthusiastic and very*/}
          {/*            knowledgeable! Such a great resource for anyone wanting to*/}
          {/*            get fit but not sure how to or what kind of exercise they*/}
          {/*            like. So many different things to try and extremely*/}
          {/*            flexible!*/}
          {/*          </p>*/}
          {/*          <div className="testimonial-footer tbk-mb-1 tbk-hidden">*/}
          {/*            <div className="tbk-text-main tbk-mb-2 tbk-text-grey">*/}
          {/*              Natasha Cambridge, 24th May 2018*/}
          {/*            </div>*/}
          {/*            <a*/}
          {/*              className="tb-session-link virtual tbk-c-basic-violet"*/}
          {/*              href="https://techcrunch.com/2015/04/14/trube/"*/}
          {/*              target="_blank"*/}
          {/*            >*/}
          {/*              <cite>*/}
          {/*                <div*/}
          {/*                  className="tbk-text-main tbk-mb-3"*/}
          {/*                  style={{ minHeight: "78px" }}*/}
          {/*                >*/}
          {/*                  TruBe Launches To Give Londoners An On-Demand Ass*/}
          {/*                  Kicking*/}
          {/*                </div>*/}
          {/*              </cite>*/}
          {/*            </a>*/}
          {/*          </div>*/}
          {/*        </blockquote>*/}
          {/*      </div>*/}
          {/*    </div>*/}

          {/*    <div className="tb-slide tbk-w-100 tbk-shrink-0 tbk-grow tbk-rounded-lg tbk-border tbk-border-grey-light tbk-bg-basic-white tbk-shadow-trube lg:tbk-w-auto lg:tbk-basis-1/4">*/}
          {/*      <a id="testimonials-slide-3" className="anchor" target="_blank">*/}
          {/*        {" "}*/}
          {/*      </a>*/}
          {/*      <div className=" tbk-mx-1_ tbk-h-full tbk-p-2 md:tbk-p-4">*/}
          {/*        <a className="" target="_blank">*/}
          {/*          <cite>*/}
          {/*            <svg*/}
          {/*              width="157"*/}
          {/*              height="32"*/}
          {/*              viewBox="0 0 157 32"*/}
          {/*              fill="none"*/}
          {/*              xmlns="http://www.w3.org/2000/svg"*/}
          {/*              className="tbk-mb-2"*/}
          {/*            >*/}
          {/*              <path*/}
          {/*                d="M15.3001 31.7334L18.0583 3.74741C18.2144 2.31223 18.4746 2.07303 18.943 2.07303H19.2032V0.47839H14.7277V2.07303H15.0139C15.6384 2.07303 15.9506 2.52485 15.8726 3.74741L14.2853 20.4912L12.4639 3.74741C12.3077 2.44512 12.62 2.07303 13.3225 2.07303H13.4006V0.47839H7.15566V2.07303H7.46791C8.06638 2.07303 8.06638 2.31223 8.17047 3.74741L8.63884 8.02637L7.18168 21.5808L5.54239 3.77399C5.33422 2.33881 5.62045 2.09961 6.24494 2.09961H6.323V0.504969H0V2.09961H0.312246C0.962761 2.09961 1.0148 2.33881 1.17092 3.77399L3.98115 31.76H8.04036L9.62762 17.3816L11.2669 31.76C11.2669 31.7334 15.3001 31.7334 15.3001 31.7334ZM42.1794 13.395C42.1794 11.4549 42.1794 10.7638 43.3763 10.7638C44.209 10.7638 44.209 11.0828 44.209 12.704V29.3946C44.209 30.0059 44.0008 30.1122 43.6886 30.1122H43.5064V31.7068H49.8034V30.1122H49.5172C49.1009 30.1122 48.9708 29.9527 48.9708 29.3149V11.8269C48.9708 8.95658 48.3723 7.84033 45.6141 7.84033C44.0008 7.84033 42.8559 8.37188 42.1013 10.1526C41.7891 8.55792 40.9564 7.84033 38.8227 7.84033C37.0533 7.84033 36.1166 8.39846 35.4401 10.1526V7.84033L30.0538 8.29215V9.88679H30.288C30.6523 9.88679 30.9125 10.1526 30.9125 11.0562V29.2086C30.9125 29.9262 30.7563 30.1388 30.288 30.1388H30.0538V31.7334H36.0645V30.1388H35.8304C35.5181 30.1388 35.4401 30.0059 35.4401 29.5275V13.395C35.4401 11.4549 35.388 10.7638 36.611 10.7638C37.4436 10.7638 37.4436 11.0828 37.4436 12.704V29.3946C37.4436 30.0059 37.2615 30.1122 36.9753 30.1122H36.7151V31.7068H42.8819V30.1122H42.7779C42.3615 30.1122 42.1794 29.9527 42.1794 29.3149V13.395ZM86.1021 31.7334H93.6481V30.1388H93.1277C92.4772 30.1388 92.269 29.8464 92.269 28.4644V16.4248H96.2502V28.4644C96.2502 29.8464 96.068 30.1388 95.4175 30.1388H94.819V31.7334H102.313V30.1388H101.688C101.012 30.1388 100.908 29.8464 100.908 28.4644V3.74741C100.908 2.31223 101.012 2.07303 101.688 2.07303H102.313V0.47839H94.819V2.07303H95.4175C96.042 2.07303 96.2502 2.31223 96.2502 3.74741V14.5378H92.269V3.74741C92.269 2.31223 92.4512 2.07303 93.1277 2.07303H93.6481V0.47839H86.1021V2.07303H86.7787C87.4032 2.07303 87.6114 2.31223 87.6114 3.74741V29.2617C87.6114 29.9527 87.4292 30.1388 86.7787 30.1388H86.1021V31.7334ZM143.009 31.7334H148.968V30.1388H148.786C148.395 30.1388 148.343 30.0059 148.343 29.5275V13.395C148.343 11.4549 148.395 10.7638 149.592 10.7638C150.477 10.7638 150.477 11.0828 150.477 12.704V29.3946C150.477 30.0059 150.321 30.1122 150.061 30.1122H149.775V31.7068H156.098V30.1122H155.837C155.395 30.1122 155.317 29.9527 155.317 29.3149V11.8269C155.317 8.95658 154.614 7.84033 151.882 7.84033C150.087 7.84033 149.072 8.39846 148.343 10.1526V0L142.619 0.47839V2.07303H143.217C143.608 2.07303 143.842 2.31223 143.842 3.18929V29.2086C143.842 29.9262 143.712 30.1388 143.217 30.1388H143.009V31.7334ZM23.7308 31.9992C28.7267 31.9992 29.4293 27.7468 29.4293 19.9331C29.4293 12.0927 28.6747 7.86691 23.7308 7.86691C18.7869 7.86691 18.0323 12.0927 18.0323 19.9331C18.0323 27.7468 18.7348 31.9992 23.7308 31.9992ZM61.5387 31.7334H67.5495V30.1388H67.2632C66.925 30.1388 66.925 30.0059 66.925 29.5275V13.395C66.925 11.4549 66.925 10.7638 68.174 10.7638C69.0326 10.7638 69.0847 11.0828 69.0847 12.704V29.3946C69.0847 30.0059 68.8505 30.1122 68.6163 30.1122H68.3301V31.7068H74.6531V30.1122H74.3929C73.9505 30.1122 73.8464 29.9527 73.8464 29.3149V11.8269C73.8464 8.95658 73.1699 7.84033 70.4117 7.84033C68.6683 7.84033 67.6015 8.39846 66.951 10.1526V7.84033L61.1744 8.29215V9.88679H61.7989C62.1632 9.88679 62.4234 10.1526 62.4234 11.0562V29.2086C62.4234 29.9262 62.2673 30.1388 61.7989 30.1388H61.5647L61.5387 31.7334ZM116.937 31.9992C119.018 31.9992 119.773 30.9627 120.215 29.7401C120.605 31.574 121.048 31.9992 123.364 31.9992C126.096 31.9992 126.46 30.3248 126.408 27.0558H125.107C125.107 29.4212 125.055 29.6604 124.639 29.6604C124.248 29.6604 124.248 29.4743 124.248 28.1455V12.6508C124.248 9.51471 123.234 7.86691 119.643 7.86691C116.806 7.86691 113.97 8.74396 114.126 11.8801C114.204 13.3153 114.751 14.8302 116.234 14.7505C117.587 14.6707 118.212 13.9266 118.212 12.7572C118.212 11.9598 117.613 10.631 116.702 9.91337C117.041 9.7539 117.587 9.59444 118.498 9.59444C119.513 9.59444 119.695 10.3918 119.695 11.9067V16.2388C114.517 18.0461 113.424 18.7636 113.424 25.408C113.45 30.2185 114.595 31.9992 116.937 31.9992ZM107.985 31.9992C111.837 31.9992 112.747 30.8032 112.539 24.2652H110.952C110.952 29.4478 110.796 29.8464 109 29.8464C106.867 29.8464 106.867 28.8896 106.867 20.0128V19.2952H113.112C113.112 10.3386 112.149 7.86691 108.011 7.86691C104.265 7.86691 102.313 10.2323 102.313 20.0925C102.287 29.5009 103.77 32.0523 107.985 31.9992ZM56.1264 31.9992C59.9254 31.9992 60.9663 30.8032 60.8101 24.2652H59.2229C59.2229 29.4478 58.9887 29.8464 57.1412 29.8464C54.8254 29.8464 54.9555 28.8896 54.9555 20.0128V19.2952H60.9923C60.9923 10.3386 60.1856 7.86691 56.1004 7.86691C52.3274 7.86691 50.3759 10.2323 50.3759 20.0925C50.3759 29.5009 51.859 32.0523 56.1264 31.9992ZM127.267 31.7334H133.512V30.1388H133.043C132.653 30.1388 132.497 29.9261 132.497 29.2883V0L126.694 0.47839V2.07303H127.371C127.761 2.07303 127.917 2.2325 127.917 2.87036V29.368C127.917 29.9527 127.865 30.1388 127.605 30.1388H127.293L127.267 31.7334ZM81.6786 31.9992C84.5409 31.9992 86.0241 30.0856 86.0241 27.2153C86.0241 20.4912 80.0393 16.5843 80.0393 11.7472C80.0393 10.2589 80.5598 9.83364 81.5746 9.83364C83.0577 9.83364 83.2919 10.4715 83.5521 12.7306L83.7863 14.9631H85.5037V8.02637H84.1506C84.0725 8.90343 83.8904 9.22235 83.7863 9.11604C83.37 8.61107 82.3552 7.84033 80.6638 7.84033C78.1659 7.84033 75.9801 8.98316 75.9801 12.7837C75.9801 18.6839 81.9128 23.1755 81.9128 27.6936C81.9128 29.6338 81.4965 29.9527 80.1174 29.9527C78.7643 29.9527 78.4 29.3149 78.1398 26.3648L77.9317 24.3981H76.1363V31.7068H77.6975C77.8276 30.9095 78.0878 30.4045 78.322 30.6172C78.8424 31.255 79.3888 31.9992 81.6786 31.9992ZM134.683 26.79C134.683 30.564 135.229 31.9992 138.898 31.9992C141.474 31.9992 142.072 30.9627 142.072 28.0657V24.1057H140.511V28.2518C140.511 29.6338 140.381 29.7933 139.887 29.7933C139.366 29.7933 139.262 29.6338 139.262 28.4112V9.83364H142.098V8.02637H139.288V2.04646H137.701C136.556 7.36194 135.593 8.02637 134.058 8.02637H133.642V9.78048H134.683V26.79ZM23.7308 29.9527C22.6379 29.9527 22.6379 29.3149 22.6379 19.9065C22.6379 10.4715 22.6379 9.83364 23.7308 9.83364C24.8236 9.83364 24.8236 10.4715 24.8236 19.9065C24.8236 29.368 24.8236 29.9527 23.7308 29.9527ZM75.1995 9.03632C79.1026 6.08622 79.8832 3.85372 78.5822 1.80726C77.8796 0.691009 76.2664 -0.0265798 75.0954 0.956784C73.6903 2.15277 74.0286 4.22581 76.6567 5.42179C76.1883 5.97991 75.0954 7.06959 74.1847 7.97322L75.1995 9.03632ZM118.81 29.2086C117.873 29.2086 117.873 28.2252 117.873 25.0625C117.873 19.3218 117.873 18.551 119.747 17.5145V27.3481C119.747 28.8631 119.539 29.2086 118.81 29.2086ZM54.9555 17.6208C55.0336 10.1526 55.1637 9.80706 56.1785 9.80706C57.1412 9.80706 57.0892 10.2057 57.0892 17.6208H54.9555ZM106.867 17.6208C106.997 10.1526 107.049 9.80706 108.064 9.80706C109.078 9.80706 108.922 10.2057 108.922 17.6208H106.867Z"*/}
          {/*                fill="black"*/}
          {/*              />*/}
          {/*            </svg>*/}
          {/*          </cite>*/}
          {/*        </a>*/}
          {/*        <h5 className="tbk-text-title-bold tbk-text-basic-trueblack">*/}
          {/*          Great resource for anyone*/}
          {/*        </h5>*/}
          {/*        <div className="tbk-text-h3-subtitle tbk-mb-2 tbk-text-grey">*/}
          {/*          Jack Fielding, 2nd Sept 2018*/}
          {/*        </div>*/}
          {/*        <blockquote>*/}
          {/*          <p*/}
          {/*            className="tbk-text-main tbk-relative tbk-mb-5 tbk-text-primary"*/}
          {/*            style={{ minHeight: "260px" }}*/}
          {/*          >*/}
          {/*            The instructors and organisers have been consistently*/}
          {/*            helpful and go above and beyond to ensure the service we*/}
          {/*            offer to our members is consistent yet adaptable when we*/}
          {/*            need it to be. I would without a doubt recommend TruBe.*/}
          {/*          </p>*/}
          {/*          <div className="testimonial-footer tbk-mb-1 tbk-hidden">*/}
          {/*            <div className="tbk-text-main tbk-c-grey-medium tbk-mb-3">*/}
          {/*              Jack Fielding, 2nd Sept 2018*/}
          {/*            </div>*/}

          {/*            <a*/}
          {/*              className="tb-session-link virtual tbk-c-basic-violet"*/}
          {/*              href="https://www.womenshealthmag.com/uk/health/a702821/the-wellbeing-start-ups-on-our-radar/"*/}
          {/*              target="_blank"*/}
          {/*            >*/}
          {/*              <cite>*/}
          {/*                <div*/}
          {/*                  className="tbk-text-main tbk-mb-3"*/}
          {/*                  style={{ minHeight: "78px" }}*/}
          {/*                >*/}
          {/*                  A few tech companies, taking the wellth world by*/}
          {/*                  storm*/}
          {/*                </div>*/}
          {/*              </cite>*/}
          {/*            </a>*/}
          {/*          </div>*/}
          {/*        </blockquote>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}

          {/*  <div className="tb-slider-buttons ">*/}
          {/*    <a*/}
          {/*      href="#testimonials-slide-2"*/}
          {/*      className="tb-pd-1 tbk-rounded-lg-circle tb-shadow-box js-slider-next tbk-bg-basic-white"*/}
          {/*    >*/}
          {/*      <svg*/}
          {/*        className="tb-icon icon-close tbk-c-grey-inactive"*/}
          {/*        width="24px"*/}
          {/*        height="24px"*/}
          {/*      ></svg>*/}
          {/*    </a>*/}
          {/*  </div>*/}
          {/*</div>*/}

          <Slider
            // ref={sliderRef}
            className={`corporate-page-testimonials-slider tbk-h-[690px]_ tbk-overflow-hidden_ tbk-bg-[#777777]_ !tbk-pt-0_ lg:tbk-mb-7_ lg:tbk-min-h-[690px]_`}
            dots={false}
            // arrows={clientWidth() > 960}
            arrows={true}
            autoplay={false}
            autoplaySpeed={6000}
            pauseOnFocus
            pauseOnDotsHover
            pauseOnHover
            infinite={false}
            initialSlide={0}
            lazyLoad="progressive"
            speed={500}
            slidesToShow={3}
            slidesToScroll={1}
            useTransform={false}
            responsive={[
              {
                breakpoint: 3000,
                settings: {
                  slidesToShow: 3,
                  // infinite: true
                  // centerMode: true,
                  // centerPadding: "8px",
                },
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                  // infinite: true
                  // centerMode: true,
                  // centerPadding: "8px",
                },
              },
              {
                breakpoint: 800,
                settings: {
                  slidesToShow: 1,
                  // infinite: true
                  // centerMode: true,
                  // centerPadding: "8px",
                },
              },
              {
                breakpoint: 526,
                settings: {
                  slidesToShow: 1,
                  // infinite: true
                  // centerMode: true,
                  // centerPadding: "8px",
                },
              },
            ]}
            // adaptiveHeight
            nextArrow={
              <SliderNextArrow
                buttonClassName="tbk-text-basic-white_ tbk-backdrop-blur-xl hover:tbk-bg-basic-white hover:tbk-text-basic-trueblack"
                // onClick={handleSlideSwipe}
              />
            }
            prevArrow={<div />}
            // onSwipe={handleSlideSwipe}
          >
            <div className="lg:tbk-shadow-trube_ lg:tbk-px-1_ lg:tbk-bg-basic-white_ tbk-p-2__ tbk-rounded-2xl lg:tbk-bg-basic-white lg:tbk-shadow-trube ">
              <div className="_lg:tbk-shadow-trube    tbk-p-2">
                <a className="" target="_blank">
                  <cite>
                    <svg
                      id="f331c3a2-736f-4a93-89be-04f63aa04043"
                      data-name="Layer 1"
                      xmlns="http://www.w3.org/2000/svg"
                      width="188"
                      height="32"
                      viewBox="0 0 93.19 19.92"
                      className="tbk-mb-2"
                    >
                      <path
                        d="M7.89,9.64a8.67,8.67,0,0,1,1.52.1,1.76,1.76,0,0,1,1.17,1.42,2.73,2.73,0,0,1-.1.82,26.65,26.65,0,0,1-1.67,3.25c-.54-.87-1.8-3.33-2.24-4.29a2.66,2.66,0,0,1-.29-.9C6.28,9.74,6.88,9.64,7.89,9.64Zm-7.16,0a1.65,1.65,0,0,1,1.29,1c1.55,2.84,3.1,6,4.61,9.06a1,1,0,0,0,.73.19,1.07,1.07,0,0,0,.73-.19c.72-1.36,2.61-5,3.43-6.41,1,1.74,2.59,4.93,3.26,6.41a1,1,0,0,0,.72.19,1,1,0,0,0,.73-.19q2-4.39,4.23-8.69c.51-1,.72-1.27,1.77-1.47l.44-.07c.25-.26.19-.85-.09-1-.7.05-1.52.08-2.44.08s-1.54,0-2.59-.08c-.31.11-.31.76-.12,1l.53.1c.55.11.79.25.79.39a3.27,3.27,0,0,1-.29,1c-.5,1.27-1,2.61-1.76,4.19-.69-1.32-1.57-3.09-2.14-4.4a2.19,2.19,0,0,1-.25-.84c0-.14.43-.28,1.16-.42l.47-.07c.23-.12.26-.93-.09-1-1.86.05-3.73.08-5.59.08H3.88c-1.32,0-2.33,0-3.62-.08-.33.13-.33.73-.11,1Z"
                        transform="translate(0 0)"
                      />
                      <path
                        d="M27.1,9.46A1.47,1.47,0,0,1,28.77,11c0,.27-.06.55-.22.63a2.86,2.86,0,0,1-1.29.24H26.09c-1,0-1.45,0-1.45-.41a2.44,2.44,0,0,1,2.46-2Zm0,10.43a6.2,6.2,0,0,0,5.52-3.12.69.69,0,0,0-.82-.63,3.26,3.26,0,0,1-2.94,1.42c-2.93,0-4.45-2-4.45-4,0-.43.07-.49.79-.49h6.06c1,0,1.14-.38,1.14-.9,0-2.1-1.77-3.93-5-3.93-3.94,0-6.82,2.68-6.82,6.12C20.5,17.29,22.81,19.89,27.07,19.89ZM40.44,9.64a8.81,8.81,0,0,1,1.52.1,1.75,1.75,0,0,1,1.16,1.42A3,3,0,0,1,43,12a28.15,28.15,0,0,1-1.67,3.25c-.55-.87-1.8-3.33-2.24-4.29a2.66,2.66,0,0,1-.29-.9C38.83,9.74,39.43,9.64,40.44,9.64Zm-7.17,0a1.66,1.66,0,0,1,1.3,1c1.54,2.84,3.1,6,4.61,9.06a1,1,0,0,0,.73.19,1,1,0,0,0,.72-.19c.73-1.36,2.62-5,3.44-6.41,1,1.74,2.59,4.93,3.25,6.41a1,1,0,0,0,.73.19,1,1,0,0,0,.72-.19q2-4.39,4.24-8.69c.5-1,.72-1.27,1.76-1.47l.45-.07c.25-.26.18-.85-.1-1-.7.05-1.51.08-2.43.08s-1.73,0-2.59-.08c-.32.11-.32.76-.12,1l.53.1c.54.11.79.25.79.39A3.79,3.79,0,0,1,51,11c-.51,1.27-1,2.61-1.77,4.19-.7-1.32-1.58-3.09-2.15-4.4a2.19,2.19,0,0,1-.25-.84c0-.14.44-.28,1.17-.42l.47-.07c.22-.12.25-.93-.1-1-2,.05-3.6.08-5.58.08H36.43c-1.21,0-2.42,0-3.63-.08-.31.13-.31.73-.09,1Z"
                        transform="translate(0 0)"
                      />
                      <path
                        d="M60.3,9.46c1.79,0,2.68,2.29,2.71,4.94,0,2.46-.57,4.23-2.37,4.23s-2.87-2.1-2.87-5,1.14-4.2,2.53-4.2Zm0,10.43c3.88,0,7.26-1.89,7.26-5.88S64.21,8.2,60.49,8.2s-7.3,2.16-7.27,6.06S56.54,19.89,60.3,19.89Z"
                        transform="translate(0 0)"
                      />
                      <path
                        d="M72.94,10.51c.2,0,.48,0,1.2.55a1.86,1.86,0,0,0,1.23.49,1.79,1.79,0,0,0,2-1.77,1.65,1.65,0,0,0-1.74-1.61c-1.32,0-2.23.9-3.09,1.36-.25,0-.32-.13-.32-.33s.07-.62.12-1.17a.66.66,0,0,0-.56-.25,23,23,0,0,1-4.61,1.65.59.59,0,0,0,0,.82l.45.24c.59.33.59.66.59,1.75v4.12c0,1.91-.12,2.15-1.17,2.24l-.6,0a.67.67,0,0,0,0,1c1.24-.06,2.48-.09,3.72-.08,1.48,0,2.75,0,4.27.08a.68.68,0,0,0,0-1l-1-.08c-1.05-.08-1.17-.3-1.17-2.21v-4.2c0-1,.16-1.65.6-1.65"
                        transform="translate(0 0)"
                      />
                      <path
                        d="M85.33,18.56l-.41.08a.63.63,0,0,0,.12.95c.89-.05,2-.08,3.89-.08s3,0,4,.08c.32-.1.38-.76.13-.95l-.47-.08a4,4,0,0,1-1.86-.63,43,43,0,0,1-4.13-5.21,1,1,0,0,1-.24-.47c0-.08,0-.18.19-.35a19.07,19.07,0,0,1,2.12-1.59,5.62,5.62,0,0,1,2.12-1l1-.19a.68.68,0,0,0-.13-1,52.86,52.86,0,0,1-6,.39h-.75c-.32.11-.35.71-.07,1l.79.11c.29,0,.6.13.6.27s-.15.47-.75,1.09l-1.33,1.35a2.5,2.5,0,0,1-1.83.76c-.34,0-.45-.08-.45-.38V4.18c0-1.73,0-2.87.11-4A.76.76,0,0,0,81.45,0a37.84,37.84,0,0,1-4.83,1.52.57.57,0,0,0,0,.82l.53.28c.63.33.63.63.63,1.72v12c0,1.91-.12,2.13-1.27,2.24l-.59.06a.67.67,0,0,0,0,1c1.28-.06,2.57-.09,3.85-.08,1.45,0,2.78,0,3.79.08a.67.67,0,0,0,0-1l-.5-.06c-1.11-.11-1.24-.33-1.24-2.24V14.77c0-.52.16-.66.38-.66a.94.94,0,0,1,.8.4l2.24,3a3,3,0,0,1,.53.88c0,.1-.19.15-.5.21"
                        transform="translate(0 0)"
                      />
                    </svg>
                  </cite>
                </a>

                <h5 className="tbk-text-epic-medium lg:tbk-text-title-bold tbk-text-primary">
                  An experience like no other
                </h5>
                <blockquote>
                  <p
                    className="tbk-text-main tbk-relative tbk-mb-5 tbk-text-primary"
                    style={{ minHeight: "208px" }}
                  >
                    TruBe have been excellent in WeWork, the masseuse that come
                    in are always very professional, they are always on time so
                    no one over runs for their meetings and the members in the
                    building always have such great feedback. I will enjoy to
                    continuously work with them
                  </p>
                  <div className="testimonial-footer hidden tbk-mb-1">
                    <div className="tbk-text-main tbk-c-grey-medium tbk-mb-3">
                      Maddie North, 11th July 2019
                    </div>
                    <a
                      className="tb-session-link virtual tbk-c-basic-violet"
                      href="https://www.marieclaire.co.uk/life/health-fitness/motivation-monday-trube-the-on-demand-personal-training-app-71395"
                      target="_blank"
                    >
                      <cite>
                        <div
                          className="tbk-text-main tbk-mb-3"
                          style={{ minHeight: "78px" }}
                        >
                          Motivation Monday: Here's What You Need To Know About
                          TruBe, The On-Demand Personal Training App
                        </div>
                      </cite>
                    </a>
                  </div>
                </blockquote>
              </div>
            </div>

            <div className="lg:tbk-shadow-trube_ lg:tbk-px-1_ lg:tbk-bg-basic-white_ tbk-p-2_ tbk-h-full tbk-rounded-2xl lg:tbk-bg-basic-white lg:tbk-shadow-trube ">
              <div className="_lg:tbk-shadow-trube    tbk-p-2">
                <a className="" target="_blank">
                  <cite>
                    <svg
                      width="224"
                      height="32"
                      viewBox="0 0 224 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="tbk-mb-2"
                    >
                      <path
                        d="M41.8086 10.6667H62.7317V0H41.8086V10.6667Z"
                        fill="#0A9E01"
                      />
                      <path
                        d="M0 0V10.6667H10.4429V32H20.8858V10.6667H31.366V0H0Z"
                        fill="#0A9E01"
                      />
                      <path
                        d="M31.3662 32H62.7322V21.3333H41.8091V10.6667H31.3662V32Z"
                        fill="#0A9E01"
                      />
                      <path
                        d="M89.3992 8.05594H74.0332V12.4942H79.1801V26.4056H84.2523V12.4942H89.3992V8.05594Z"
                        fill="#0A9E01"
                      />
                      <path
                        d="M95.179 12.345C91.5613 12.345 88.876 14.7692 88.876 19.5431C88.876 23.7576 91.151 26.704 95.2909 26.704C97.4541 26.704 99.207 26.1445 100.885 25.1375L99.0951 22.1166C97.7151 22.8252 96.7454 23.0862 95.5147 23.0862C94.2466 23.0862 93.3515 22.4149 93.165 20.8858H101.258C101.296 20.662 101.296 20.3636 101.296 19.9534C101.333 14.8438 98.9832 12.345 95.179 12.345ZM93.2396 17.9394C93.3888 16.5594 93.9855 15.8508 95.0671 15.8508C96.4471 15.8508 96.9319 16.5594 97.1557 17.9394H93.2396Z"
                        fill="#0A9E01"
                      />
                      <path
                        d="M110.284 22.8625C109.016 22.8625 108.345 21.7436 108.345 19.5431C108.345 17.38 108.941 16.1492 110.172 16.1492C111.179 16.1492 111.627 16.7086 112.298 17.9394L115.543 15.4779C114.349 13.5385 112.857 12.345 110.247 12.345C105.846 12.345 103.683 15.2541 103.683 19.4685C103.683 24.0932 106.107 26.6667 110.135 26.6667C112.559 26.6667 114.051 25.7343 115.655 23.3846L112.671 21.035C111.776 22.3776 111.179 22.8625 110.284 22.8625Z"
                        fill="#0A9E01"
                      />
                      <path
                        d="M126.546 12.345C124.905 12.345 123.935 12.9044 123.077 13.5385V7.31003L118.341 9.21213V26.4429H123.077V18.5734C123.077 16.8578 123.674 16.373 124.681 16.373C125.651 16.373 126.248 16.8578 126.248 18.6107V26.4429H130.984V18.014C130.984 14.3963 129.53 12.345 126.546 12.345Z"
                        fill="#0A9E01"
                      />
                      <path
                        d="M142.359 22.2657C140.158 22.2657 139.263 20.028 139.263 17.2308C139.263 14.3217 140.195 12.1958 142.321 12.1958C144 12.1958 144.634 13.2774 145.268 14.993L149.892 13.1655C148.624 9.69698 146.834 7.75758 142.321 7.75758C137.398 7.75758 133.93 11.338 133.93 17.2308C133.93 22.676 136.839 26.704 142.284 26.704C146.648 26.704 148.699 24.3543 149.93 21.9674L145.641 19.6923C144.634 21.4079 143.962 22.2657 142.359 22.2657Z"
                        fill="black"
                      />
                      <path
                        d="M157.538 13.6504V12.6434H152.802V26.4056H157.538V18.9091C157.538 17.2308 158.247 16.6713 159.403 16.6713C160.336 16.6713 161.007 17.1562 161.604 17.8275L162.722 12.9417C162.163 12.6061 161.492 12.345 160.485 12.345C159.254 12.345 158.322 12.8671 157.538 13.6504Z"
                        fill="black"
                      />
                      <path
                        d="M172.829 20.5128C172.829 22.2284 172.233 22.7133 171.263 22.7133C170.293 22.7133 169.697 22.2284 169.697 20.4755V12.6433H164.96V21.0723C164.96 24.69 166.415 26.704 169.435 26.704C171.039 26.704 172.046 26.1445 172.867 25.5105V26.4429H177.603V12.6806H172.867V20.5128"
                        fill="black"
                      />
                      <path
                        d="M189.202 12.345C187.561 12.345 186.591 12.9044 185.734 13.5385V12.6061H180.997V26.3683H185.734V18.4988C185.734 16.7832 186.33 16.2984 187.337 16.2984C188.307 16.2984 188.904 16.7832 188.904 18.5361V26.3683H193.64V17.9394C193.64 14.3963 192.223 12.345 189.202 12.345Z"
                        fill="black"
                      />
                      <path
                        d="M203.039 22.8625C201.771 22.8625 201.1 21.7436 201.1 19.5431C201.1 17.38 201.696 16.1492 202.89 16.1492C203.897 16.1492 204.344 16.7086 205.016 17.9394L208.261 15.4779C207.067 13.5385 205.575 12.345 202.965 12.345C198.564 12.345 196.4 15.2541 196.4 19.4685C196.4 24.0932 198.825 26.6667 202.853 26.6667C205.277 26.6667 206.769 25.7343 208.372 23.3846L205.389 21.035C204.568 22.3776 203.934 22.8625 203.039 22.8625Z"
                        fill="black"
                      />
                      <path
                        d="M219.301 12.345C217.66 12.345 216.69 12.9044 215.832 13.5385V7.31003L211.096 9.21213V26.4429H215.832V18.5734C215.832 16.8578 216.429 16.373 217.436 16.373C218.406 16.373 219.002 16.8578 219.002 18.6107V26.4429H223.739V18.014C223.776 14.3963 222.322 12.345 219.301 12.345Z"
                        fill="black"
                      />
                    </svg>
                  </cite>
                </a>
                <h5 className="tbk-text-epic-medium lg:tbk-text-title-bold tbk-text-primary">
                  Fantastic experience
                </h5>
                <blockquote>
                  <p
                    className="tbk-text-main tbk-relative tbk-mb-5 tbk-text-primary"
                    style={{ minHeight: "208px" }}
                  >
                    TruBe trainers are fun, enthusiastic and very knowledgeable!
                    Such a great resource for anyone wanting to get fit but not
                    sure how to or what kind of exercise they like. So many
                    different things to try and extremely flexible!
                  </p>
                  <div className="testimonial-footer hidden tbk-mb-1">
                    <div className="tbk-text-main tbk-c-grey-medium tbk-mb-3">
                      Natasha Cambridge, 24th May 2018
                    </div>
                    <a
                      className="tb-session-link virtual tbk-c-basic-violet"
                      href="https://techcrunch.com/2015/04/14/trube/"
                      target="_blank"
                    >
                      <cite>
                        <div
                          className="tbk-text-main tbk-mb-3"
                          style={{ minHeight: "78px" }}
                        >
                          TruBe Launches To Give Londoners An On-Demand Ass
                          Kicking
                        </div>
                      </cite>
                    </a>
                  </div>
                </blockquote>
              </div>
            </div>

            <div className="lg:tbk-shadow-trube_ lg:tbk-px-1_ tbk-p-2_ tbk-h-full tbk-rounded-2xl lg:tbk-bg-basic-white lg:tbk-shadow-trube ">
              <div className="_lg:tbk-shadow-trube    tbk-p-2">
                <a className="" target="_blank">
                  <cite>
                    <svg
                      width="157"
                      height="32"
                      viewBox="0 0 157 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="tbk-mb-2"
                    >
                      <path
                        d="M15.3001 31.7334L18.0583 3.74741C18.2144 2.31223 18.4746 2.07303 18.943 2.07303H19.2032V0.47839H14.7277V2.07303H15.0139C15.6384 2.07303 15.9506 2.52485 15.8726 3.74741L14.2853 20.4912L12.4639 3.74741C12.3077 2.44512 12.62 2.07303 13.3225 2.07303H13.4006V0.47839H7.15566V2.07303H7.46791C8.06638 2.07303 8.06638 2.31223 8.17047 3.74741L8.63884 8.02637L7.18168 21.5808L5.54239 3.77399C5.33422 2.33881 5.62045 2.09961 6.24494 2.09961H6.323V0.504969H0V2.09961H0.312246C0.962761 2.09961 1.0148 2.33881 1.17092 3.77399L3.98115 31.76H8.04036L9.62762 17.3816L11.2669 31.76C11.2669 31.7334 15.3001 31.7334 15.3001 31.7334ZM42.1794 13.395C42.1794 11.4549 42.1794 10.7638 43.3763 10.7638C44.209 10.7638 44.209 11.0828 44.209 12.704V29.3946C44.209 30.0059 44.0008 30.1122 43.6886 30.1122H43.5064V31.7068H49.8034V30.1122H49.5172C49.1009 30.1122 48.9708 29.9527 48.9708 29.3149V11.8269C48.9708 8.95658 48.3723 7.84033 45.6141 7.84033C44.0008 7.84033 42.8559 8.37188 42.1013 10.1526C41.7891 8.55792 40.9564 7.84033 38.8227 7.84033C37.0533 7.84033 36.1166 8.39846 35.4401 10.1526V7.84033L30.0538 8.29215V9.88679H30.288C30.6523 9.88679 30.9125 10.1526 30.9125 11.0562V29.2086C30.9125 29.9262 30.7563 30.1388 30.288 30.1388H30.0538V31.7334H36.0645V30.1388H35.8304C35.5181 30.1388 35.4401 30.0059 35.4401 29.5275V13.395C35.4401 11.4549 35.388 10.7638 36.611 10.7638C37.4436 10.7638 37.4436 11.0828 37.4436 12.704V29.3946C37.4436 30.0059 37.2615 30.1122 36.9753 30.1122H36.7151V31.7068H42.8819V30.1122H42.7779C42.3615 30.1122 42.1794 29.9527 42.1794 29.3149V13.395ZM86.1021 31.7334H93.6481V30.1388H93.1277C92.4772 30.1388 92.269 29.8464 92.269 28.4644V16.4248H96.2502V28.4644C96.2502 29.8464 96.068 30.1388 95.4175 30.1388H94.819V31.7334H102.313V30.1388H101.688C101.012 30.1388 100.908 29.8464 100.908 28.4644V3.74741C100.908 2.31223 101.012 2.07303 101.688 2.07303H102.313V0.47839H94.819V2.07303H95.4175C96.042 2.07303 96.2502 2.31223 96.2502 3.74741V14.5378H92.269V3.74741C92.269 2.31223 92.4512 2.07303 93.1277 2.07303H93.6481V0.47839H86.1021V2.07303H86.7787C87.4032 2.07303 87.6114 2.31223 87.6114 3.74741V29.2617C87.6114 29.9527 87.4292 30.1388 86.7787 30.1388H86.1021V31.7334ZM143.009 31.7334H148.968V30.1388H148.786C148.395 30.1388 148.343 30.0059 148.343 29.5275V13.395C148.343 11.4549 148.395 10.7638 149.592 10.7638C150.477 10.7638 150.477 11.0828 150.477 12.704V29.3946C150.477 30.0059 150.321 30.1122 150.061 30.1122H149.775V31.7068H156.098V30.1122H155.837C155.395 30.1122 155.317 29.9527 155.317 29.3149V11.8269C155.317 8.95658 154.614 7.84033 151.882 7.84033C150.087 7.84033 149.072 8.39846 148.343 10.1526V0L142.619 0.47839V2.07303H143.217C143.608 2.07303 143.842 2.31223 143.842 3.18929V29.2086C143.842 29.9262 143.712 30.1388 143.217 30.1388H143.009V31.7334ZM23.7308 31.9992C28.7267 31.9992 29.4293 27.7468 29.4293 19.9331C29.4293 12.0927 28.6747 7.86691 23.7308 7.86691C18.7869 7.86691 18.0323 12.0927 18.0323 19.9331C18.0323 27.7468 18.7348 31.9992 23.7308 31.9992ZM61.5387 31.7334H67.5495V30.1388H67.2632C66.925 30.1388 66.925 30.0059 66.925 29.5275V13.395C66.925 11.4549 66.925 10.7638 68.174 10.7638C69.0326 10.7638 69.0847 11.0828 69.0847 12.704V29.3946C69.0847 30.0059 68.8505 30.1122 68.6163 30.1122H68.3301V31.7068H74.6531V30.1122H74.3929C73.9505 30.1122 73.8464 29.9527 73.8464 29.3149V11.8269C73.8464 8.95658 73.1699 7.84033 70.4117 7.84033C68.6683 7.84033 67.6015 8.39846 66.951 10.1526V7.84033L61.1744 8.29215V9.88679H61.7989C62.1632 9.88679 62.4234 10.1526 62.4234 11.0562V29.2086C62.4234 29.9262 62.2673 30.1388 61.7989 30.1388H61.5647L61.5387 31.7334ZM116.937 31.9992C119.018 31.9992 119.773 30.9627 120.215 29.7401C120.605 31.574 121.048 31.9992 123.364 31.9992C126.096 31.9992 126.46 30.3248 126.408 27.0558H125.107C125.107 29.4212 125.055 29.6604 124.639 29.6604C124.248 29.6604 124.248 29.4743 124.248 28.1455V12.6508C124.248 9.51471 123.234 7.86691 119.643 7.86691C116.806 7.86691 113.97 8.74396 114.126 11.8801C114.204 13.3153 114.751 14.8302 116.234 14.7505C117.587 14.6707 118.212 13.9266 118.212 12.7572C118.212 11.9598 117.613 10.631 116.702 9.91337C117.041 9.7539 117.587 9.59444 118.498 9.59444C119.513 9.59444 119.695 10.3918 119.695 11.9067V16.2388C114.517 18.0461 113.424 18.7636 113.424 25.408C113.45 30.2185 114.595 31.9992 116.937 31.9992ZM107.985 31.9992C111.837 31.9992 112.747 30.8032 112.539 24.2652H110.952C110.952 29.4478 110.796 29.8464 109 29.8464C106.867 29.8464 106.867 28.8896 106.867 20.0128V19.2952H113.112C113.112 10.3386 112.149 7.86691 108.011 7.86691C104.265 7.86691 102.313 10.2323 102.313 20.0925C102.287 29.5009 103.77 32.0523 107.985 31.9992ZM56.1264 31.9992C59.9254 31.9992 60.9663 30.8032 60.8101 24.2652H59.2229C59.2229 29.4478 58.9887 29.8464 57.1412 29.8464C54.8254 29.8464 54.9555 28.8896 54.9555 20.0128V19.2952H60.9923C60.9923 10.3386 60.1856 7.86691 56.1004 7.86691C52.3274 7.86691 50.3759 10.2323 50.3759 20.0925C50.3759 29.5009 51.859 32.0523 56.1264 31.9992ZM127.267 31.7334H133.512V30.1388H133.043C132.653 30.1388 132.497 29.9261 132.497 29.2883V0L126.694 0.47839V2.07303H127.371C127.761 2.07303 127.917 2.2325 127.917 2.87036V29.368C127.917 29.9527 127.865 30.1388 127.605 30.1388H127.293L127.267 31.7334ZM81.6786 31.9992C84.5409 31.9992 86.0241 30.0856 86.0241 27.2153C86.0241 20.4912 80.0393 16.5843 80.0393 11.7472C80.0393 10.2589 80.5598 9.83364 81.5746 9.83364C83.0577 9.83364 83.2919 10.4715 83.5521 12.7306L83.7863 14.9631H85.5037V8.02637H84.1506C84.0725 8.90343 83.8904 9.22235 83.7863 9.11604C83.37 8.61107 82.3552 7.84033 80.6638 7.84033C78.1659 7.84033 75.9801 8.98316 75.9801 12.7837C75.9801 18.6839 81.9128 23.1755 81.9128 27.6936C81.9128 29.6338 81.4965 29.9527 80.1174 29.9527C78.7643 29.9527 78.4 29.3149 78.1398 26.3648L77.9317 24.3981H76.1363V31.7068H77.6975C77.8276 30.9095 78.0878 30.4045 78.322 30.6172C78.8424 31.255 79.3888 31.9992 81.6786 31.9992ZM134.683 26.79C134.683 30.564 135.229 31.9992 138.898 31.9992C141.474 31.9992 142.072 30.9627 142.072 28.0657V24.1057H140.511V28.2518C140.511 29.6338 140.381 29.7933 139.887 29.7933C139.366 29.7933 139.262 29.6338 139.262 28.4112V9.83364H142.098V8.02637H139.288V2.04646H137.701C136.556 7.36194 135.593 8.02637 134.058 8.02637H133.642V9.78048H134.683V26.79ZM23.7308 29.9527C22.6379 29.9527 22.6379 29.3149 22.6379 19.9065C22.6379 10.4715 22.6379 9.83364 23.7308 9.83364C24.8236 9.83364 24.8236 10.4715 24.8236 19.9065C24.8236 29.368 24.8236 29.9527 23.7308 29.9527ZM75.1995 9.03632C79.1026 6.08622 79.8832 3.85372 78.5822 1.80726C77.8796 0.691009 76.2664 -0.0265798 75.0954 0.956784C73.6903 2.15277 74.0286 4.22581 76.6567 5.42179C76.1883 5.97991 75.0954 7.06959 74.1847 7.97322L75.1995 9.03632ZM118.81 29.2086C117.873 29.2086 117.873 28.2252 117.873 25.0625C117.873 19.3218 117.873 18.551 119.747 17.5145V27.3481C119.747 28.8631 119.539 29.2086 118.81 29.2086ZM54.9555 17.6208C55.0336 10.1526 55.1637 9.80706 56.1785 9.80706C57.1412 9.80706 57.0892 10.2057 57.0892 17.6208H54.9555ZM106.867 17.6208C106.997 10.1526 107.049 9.80706 108.064 9.80706C109.078 9.80706 108.922 10.2057 108.922 17.6208H106.867Z"
                        fill="black"
                      />
                    </svg>
                  </cite>
                </a>
                <h5 className="tbk-text-epic-medium lg:tbk-text-title-bold tbk-text-primary">
                  Great resource for anyone
                </h5>
                <blockquote>
                  <p
                    className="tbk-text-main tbk-relative tbk-mb-5 tbk-text-primary"
                    style={{ minHeight: "208px" }}
                  >
                    The instructors and organisers have been consistently
                    helpful and go above and beyond to ensure the service we
                    offer to our members is consistent yet adaptable when we
                    need it to be. I would without a doubt recommend TruBe.
                  </p>
                  <div className="testimonial-footer hidden tbk-mb-1">
                    <div className="tbk-text-main tbk-c-grey-medium tbk-mb-3">
                      Jack Fielding, 2nd Sept 2018
                    </div>

                    <a
                      className="tb-session-link virtual tbk-c-basic-violet"
                      href="https://www.womenshealthmag.com/uk/health/a702821/the-wellbeing-start-ups-on-our-radar/"
                      target="_blank"
                    >
                      <cite>
                        <div
                          className="tbk-text-main tbk-mb-3"
                          style={{ minHeight: "78px" }}
                        >
                          A few tech companies, taking the wellth world by storm
                        </div>
                      </cite>
                    </a>
                  </div>
                </blockquote>
              </div>
            </div>
          </Slider>
        </div>
      </section>

      <section
        id="get-in-touch"
        ref={getInTouchRef}
        className="cta-form-section tbk-mb-4_ tbk-relative tbk-bg-basic-white tbk-pt-8 tbk-pb-7 md:tbk-pt-8 md:tbk-pb-7"
      >
        {/*<div className="homepage-hero-image-container hidden">*/}
        {/*  <div className="tb-repsonsive-img-container tb-absolute-fill tbk-bg-basic-trueblack">*/}
        {/*    <picture className="js-progressive-image">*/}
        {/*      <source*/}
        {/*        srcSet="<?php echo $public_path ?>/images/hero-corporate-bottom.jpg 1x, <?php echo $public_path ?>/images/hero-corporate-bottom@2x.jpg 2x"*/}
        {/*        media="(minWidth: 760px)"*/}
        {/*        type="image/jpeg"*/}
        {/*      />*/}
        {/*      <source*/}
        {/*        srcSet="<?php echo $public_path ?>/images/hero-corporate-bottom-mobile.jpg 1x, <?php echo $public_path ?>/images/hero-corporate-bottom-mobile@2x.jpg 2x"*/}
        {/*        type="image/jpeg"*/}
        {/*      />*/}
        {/*      <img*/}
        {/*        className="hero-img-picture tb-progressive-image"*/}
        {/*        aria-hidden="true"*/}
        {/*        alt="Personal Trainers in London"*/}
        {/*        src="<?php echo $public_path ?>/images/hero-corporate-bottom.jpg"*/}
        {/*        style={{*/}
        {/*          position: "absolute",*/}
        {/*          objectFit: "cover",*/}
        {/*          verticalAlign: "bottom",*/}
        {/*        }}*/}
        {/*      />*/}
        {/*    </picture>*/}
        {/*    <div*/}
        {/*      className="tb-background-image"*/}
        {/*      style={{*/}
        {/*        width: "100%",*/}
        {/*        height: "100%",*/}
        {/*        // backgroundImage: "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAACCAIAAAAfCIEKAAAAKUlEQVR4AWMRkJH99+8/ExOTkJAgMyMTy9/fv////8/Mxvbt23dGBkYAuEIMcjyBF1sAAAAASUVORK5CYII=')",*/}
        {/*        backgroundSize: "cover",*/}
        {/*        opacity: 0,*/}
        {/*      }}*/}
        {/*    ></div>*/}
        {/*  </div>*/}
        {/*</div>*/}
        <div className="tbk-container tbk-mx-auto tbk-px-2 lg:tbk-px-7">
          <div className="u-flex-top tbk-flex tbk-flex-col tbk-items-center tbk-justify-center tbk-gap-5 lg:tbk-grid-cols-2 lg:tbk-flex-row lg:tbk-items-start">
            <div className="col-md-5 tbk-w-full md:tbk-w-112">
              <CorporateContactForm />
            </div>

            <div className="col-md-4 tbk--order-1 tbk-w-full md:tbk-w-112 lg:tbk-order-1">
              <div className="tbk-flex tbk-flex-col tbk-items-center tbk-text-center md:tbk-mt-4 md:tbk-text-left lg:tbk-items-start">
                <TruBeLogo className="tbk-mb-4" />

                <h2 className="tbk-text-title-bold lg:tbk-text-epic-medium text-uppercase tbk-mt-0 tbk-mb-3 tbk-text-primary lg:tbk-mb-0 lg:tbk-mb-7 lg:!tbk-leading-none">
                  <span className="tbk-whitespace-nowrap">
                    TruBe on Demand:
                  </span>{" "}
                  <br className="" />
                  Our Solution
                  <br className="tbk-hidden lg:tbk-block" /> is{" "}
                  <span className="tbk-text-coral">Your Solution</span>
                </h2>
              </div>
            </div>
          </div>
          <div className="row u-flex-top tbk-hidden tbk-items-center">
            <div className="col-4 col-md-3 tb-spacing-extra-large">
              <div className="tbk-flex">
                <i className="tbk-mr-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                  >
                    <g fill="#E74F3A">
                      <path d="M17.3 8.2c-1.1 0-2 .9-2 2s.9 2 2 2c2 0 3.6 1.6 3.6 3.6 0 1.1.9 2 2 2s2-.9 2-2c0-4.2-3.4-7.6-7.6-7.6z" />
                      <path d="M46.5 39.3L39 31.8c-1.3-1.3-3.2-1.7-4.8-1.3L30 26.3c2-2.7 3.2-6.1 3.2-9.8C33.2 7.4 25.7 0 16.6 0 7.4 0 0 7.4 0 16.6c0 9.2 7.4 16.6 16.6 16.6 3.6 0 7-1.2 9.8-3.2l4.2 4.2c-.4 1.7 0 3.5 1.3 4.8l7.5 7.5c2 2 5.2 2 7.1 0l.1-.1c1.9-1.9 1.9-5.1-.1-7.1zM4 16.6C4 9.7 9.7 4 16.6 4c6.9 0 12.5 5.6 12.5 12.5S23.5 29 16.6 29 4 23.5 4 16.6z" />
                    </g>
                  </svg>
                </i>
                <div className="h5 tb-spacing-top-none tb-spacing-none tb-text-bold">
                  Get to know our platform
                </div>
              </div>
            </div>
            <div className="col-4 tb-spacing-extra-large">
              <div className="tbk-flex">
                <i className="tbk-mr-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="49"
                    height="48"
                    viewBox="0 0 49 48"
                  >
                    <path
                      fill="#E74F3A"
                      d="M41.314 1.037A2.13 2.13 0 0 0 39.484 0H9.516a2.13 2.13 0 0 0-1.829 1.037L.298 13.427a2.112 2.112 0 0 0 .097 2.31l22.437 31.374c.4.558 1.045.889 1.733.889h.003a2.13 2.13 0 0 0 1.733-.894L48.61 15.733a2.112 2.112 0 0 0 .093-2.306l-7.388-12.39zm-8.928 15.227l-7.824 22.813-7.845-22.813h15.669zM19.15 12.027l5.35-6.55 5.35 6.55h-10.7zm15.131-1.29l-5.309-6.5h7.538l-2.229 6.5zm-19.493-.084L12.58 4.237h7.447l-5.24 6.416zm-4.025 1.374H6.081l2.97-4.98 1.712 4.98zm1.457 4.237l5.766 16.767L5.995 16.264h6.225zm24.662 0h6.136l-11.853 16.67 5.717-16.67zm1.453-4.237l1.674-4.88 2.91 4.88h-4.584z"
                    />
                  </svg>
                </i>
                <div className="h5 tb-spacing-top-none tb-spacing-none tb-text-bold">
                  Let us find the perfect package for you
                </div>
              </div>
            </div>
            <div className="col-4 col-md-3 tb-spacing-extra-large">
              <div className="tbk-flex">
                <i className="tbk-mr-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                  >
                    <path
                      fill="#E74F3A"
                      d="M7.99 35.98C3.584 35.98 0 31.948 0 26.99S3.584 18 7.99 18c2.212 0 4.01 1.95 4.01 4.346v9.29c0 2.396-1.798 4.344-4.01 4.344zM7.902 22C5.778 22.062 4 24.322 4 26.99c0 2.698 1.818 4.976 3.972 4.99L8 31.634v-9.29L7.902 22zM40.01 35.98c-2.21 0-4.01-1.95-4.01-4.346v-9.29C36 19.95 37.798 18 40.01 18c4.406 0 7.99 4.034 7.99 8.99s-3.584 8.99-7.99 8.99zM40.028 22l-.028.346v9.29l.098.344C42.222 31.92 44 29.66 44 26.992c0-2.7-1.816-4.98-3.972-4.992zM26 48a2 2 0 1 1 0-4c8.056 0 12.978-3.492 13.856-9.832.15-1.094 1.158-1.876 2.254-1.708a1.999 1.999 0 0 1 1.708 2.254C42.65 43.158 36.156 48 26 48zm0 0c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6zm0-8c-1.102 0-2 .896-2 2s.898 2 2 2a2 2 0 0 0 0-4zm16-18a2 2 0 0 1-2-2c0-7.736-4.204-16-16-16S8 12.264 8 20a2 2 0 0 1-4 0C4 7.85 11.85 0 24 0s20 7.85 20 20a2 2 0 0 1-2 2z"
                    />
                  </svg>
                </i>
                <div className="h5 tb-spacing-top-none tb-spacing-none tb-text-bold">
                  Have full support from TruBe
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
